import {
  AddIcon,
  Box,
  CloseIcon,
  Divider,
  HStack,
  Image,
  Pressable,
  ScrollView,
  Text,
  VStack,
  Button,
  IconButton,
} from "native-base";
import React, {
  FC,
  useState,
  useRef,
  useEffect,
  Dispatch,
  SetStateAction,
} from "react";
import Tooltip from "@mui/material/Tooltip";
import { Media } from "../../AVCore/Media";
import { StyleSheet } from "react-native";
import AVCancel from "../../components/common/AVCancel";
import AVEmoji from "../../components/common/AVEmoji";
import "./style.css";
import { AVBase, Post } from "../../AVCore/AVCore";
import { Loc } from "../../App/Loc";
import { useDispatch, useSelector, RootStateOrAny } from "react-redux";
import * as AV from "../../AVCore/AVCore";
import {
  DropdownIcon,
  VideoIcon,
  ExpandIcon,
  CollapseIcon,
  BrushIcon,
  ImportBGImage,
  CancelIcon,
  FormattingIcon,
  PlainTextIcon,
  CircleSlashIcon,
  BoostIcon,
} from "../../assets/icons/icon-assets";
import { setFeeds, setFeedsUpdate } from "../../Redux/Actions/feedsAction";
import { useWindowDimension } from "../../Utility/WindowDimensions";
import AVEmojiPicker from "../../components/common/AVEmojiPicker";
import settings from "../../Platform/settings.json";
import {
  setisActive,
  setPostPopupExpanded,
  setUser,
  setEntitydata,
} from "../../Redux/Actions/userActions";
import { isMobile } from "react-device-detect";
import LinkPreview from "../../components/common/preview/LinkPreview";
import AVInputtext from "../../components/AVInputtext";
import CustomToast from "../../Hooks/useCustomToast";
import ExternalLink from "../../components/common/ExternalLink";
import useDrivePicker from "react-google-drive-picker";
import Webcam from "react-webcam";
import { FiCamera, FiVideo } from "react-icons/fi";
import axios from "axios";
import _ from "lodash";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import type SunEditorCore from "suneditor/src/lib/core";
import { SketchPicker } from "react-color";
import CreatePostGrid from "./CreatePostGrid";
import AVBoostPostPopup from "../../components/common/AVBoostPostPopup";
import PurchaseCreditsPopup from "../../components/common/PurchaseCreditsPopup";
import AVConfirmationModal from "../../components/common/AVConfirmationModal";

interface Props {
  setShowCreatePost: any | undefined;
  windowDimensions: any | undefined;
  headerHeight: any | undefined;
  item: any | undefined;
  showModal: any | undefined;
  reload: any | undefined;
  setItem: any | undefined;
  setShowDetails: any | undefined;
  setpreviewitem: any | undefined;
  setFeedChunks: any | undefined;
  feedChunks: any | undefined;
  userInfo: any | undefined;
  isHuddlePostTab: any | false;
  paySend: number;
  setPaySend: Dispatch<SetStateAction<number>>;
  subject: string;
  setSubject: Dispatch<SetStateAction<string>>;
  estimate: number | null;
  setEstimate: Dispatch<SetStateAction<number | null>>;
  showBoostPostPopup: boolean;
  setShowBoostPostPopup: Dispatch<SetStateAction<boolean>>;
  showCreditsPopup: boolean;
  setShowCreditsPopup: Dispatch<SetStateAction<boolean>>;
  estimateVisibility?: string;
  sharedPlan?: AV.ISharedPlan;
  setSharedPlan?: (plan: AV.ISharedPlan) => void;
}

const EditPostpopup: FC<Props> = ({
  setShowCreatePost,
  headerHeight,
  reload,
  windowDimensions,
  item,
  setItem,
  setShowDetails,
  setpreviewitem,
  showModal,
  setFeedChunks,
  feedChunks,
  userInfo,
  isHuddlePostTab,
  paySend,
  setPaySend,
  subject,
  setSubject,
  estimate,
  setEstimate,
  showBoostPostPopup,
  setShowBoostPostPopup,
  showCreditsPopup,
  setShowCreditsPopup,
  estimateVisibility,
  sharedPlan,
  setSharedPlan,
}) => {
  const dimensions = useWindowDimension();
  const mobile = dimensions?.width < 600 || false;
  const dispatch = useDispatch();
  const currentUser = useSelector(
    (state: RootStateOrAny) => state.user.user[0],
  );
  const userFeeds = useSelector(
    (state: RootStateOrAny) => state.feeds.feeds[0],
  );
  const entityDataList = useSelector(
    (state: RootStateOrAny) => state.user.entitydatalist,
  );

  const [images, setImages] = useState<any>([]);
  const [docs, setDocs] = useState<any>([]);
  const [links, setLinks] = useState<any>([]);
  const [media, setMedia] = useState<any>([]);
  const [videos, setvideos] = useState<any>([]);
  const [picker, setPicker] = useState(false);
  const [text, setText] = useState(item?.ptype !== "H" ? item?.text : "");
  const [isLoading, setIsLoading] = useState(false);
  const [isImageProcessing, setIsImageProcessing] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState<any>(null);
  const [isActive, setIsActive] = useState(false);
  const isstaffOfEntity = userInfo?.staff?.some(
    (x) => x?.id === currentUser?.id,
  );
  //const isEventOwner = userInfo?.participants
  //  ? userInfo.participants.some(
  //      (x) =>
  //        x?.id === currentUser?.id &&
  //        (x?.linkType === "Owner" || x?.linkType === "Staff")
  //    )
  //  : userInfo?.type === "Person" && userInfo?.id === currentUser?.id;

  const visibilityLocMap: Record<string, string> = {
    Follow: Loc.currentLang.menu.followers,
    Followers: Loc.currentLang.menu.followers,
    Private: Loc.currentLang.menu.private,
    Public: Loc.currentLang.menu.public,
    Org: Loc.currentLang.menu.organizations,
  };
  const visibilityMap: Record<string, string> = {
    [Loc.currentLang.menu.public]: "Public",
    [Loc.currentLang.menu.private]: "Private",
    [Loc.currentLang.menu.followers]: "Follow",
    [Loc.currentLang.menu.organizations]: "Org",
  };
  const [visibility, setVisibility] = useState(
    visibilityLocMap[item.visibility] || item.visibility,
  );

  const imageInputRef: any = useRef(null);
  const textEditRef: any = useRef();
  const [isTrue, setIsTrue] = useState(false);
  const [showExternalLinkInput, setShowExternalLinkInput] = useState(false);
  const [externalLink, setExternalLink] = useState("");
  const [allMedia, setAllMedia] = useState<any>([]);
  const [addLinkLoad, setAddLinkLoad] = useState(false);
  const [isOpenBox, setIsOpenBox] = useState(false);
  const [openPicker, authResponse] = useDrivePicker();
  const [oneDriveLink, setOneDriveLink] = useState<any>([]);
  const [isOpenCemera, setIsOpenCemera] = useState<any>(false);
  const [isYoutube, setIsYouTube] = useState<any>(false);
  const camera = useRef<any>(null);
  const [isCameraAccessible, setIsCameraAccessible] = useState(true);
  const [isOnedriveData, setIsOneDriveData] = useState<any>("");
  const [pdf, setpdf] = useState<any>([]);
  const [showPreview, setShowPreview] = useState(false);
  const [singleImage, setSingleImage] = useState();
  const [allImages, setShowAllImage] = useState([]);
  const [isExpanded, setIsExpanded] = useState(false);

  const isValidLink =
    /^(https?|ftp):\/\/[a-zA-Z0-9.-]+(\.[a-zA-Z]{2,})?(:\d+)?(\/\S*)?$/;

  // Confirmation Popup
  const [isConfirmDelete, setIsConfirmDelete] = useState(false);
  const [confirmationText, setConfirmationText] = useState("");
  const [selectedType, setSelectedType] = useState("");
  const [selectedItem, setSelectedItem] = useState<any>("");

  const [isOwnerOfBoost, setIsOwnerOfBoost] = useState(false);
  const [boostPostCreditsOwner, setBoostPostCreditsOwner] = useState<AV.IFK>();

  useEffect(() => {
    const checkBoostOwner = async () => {
      if (!item?.owner || !currentUser || item?.parentPost) return;

      const checkShareTypeCase = async (
        entity: AV.IAVEntity | AV.IFK,
      ): Promise<boolean> => {
        let resolvedEntity: AV.IAVEntity | null = null;

        if ("plan" in entity) {
          resolvedEntity = entity;
        } else {
          resolvedEntity =
            entityDataList?.find((x) => x?.id === entity?.id) ?? null;

          if (!resolvedEntity) {
            resolvedEntity = await AV.AVEntity.get(entity);
            if (resolvedEntity) {
              dispatch(
                setEntitydata([...(entityDataList ?? []), resolvedEntity]),
              );
            }
          }
        }

        if (!resolvedEntity?.plan?.shared) return true;

        try {
          let shared =
            entityDataList?.find(
              (x) => x.id === resolvedEntity!.plan!.shared!.id,
            ) ?? null;

          if (!shared) {
            shared = await AV.AVEntity.getSharedPlan(
              AV.AVEntity.getFk(resolvedEntity),
            );
            dispatch(setEntitydata([...(entityDataList ?? []), shared]));
          }

          setSharedPlan?.(shared);

          return !(
            shared?.owner?.id !== entity?.id && shared?.autoShareType === "NB"
          );
        } catch (e) {
          console.error("Failed to load shared plan:", e);
          return false;
        }
      };

      let ownerFlag = false;
      const isEventOrChannel =
        item?.owner?.type === "Event" ||
        item?.owner?.type === "Game" ||
        item?.owner?.type === "Channel";

      const mainOwner = isEventOrChannel ? item?.topOwner : item?.owner;

      // 1. Load entity + staff details
      let staff: AV.IStaff[] | null = null;
      const ownerId = mainOwner?.id;

      let entity = entityDataList?.find((x) => x?.id === ownerId) ?? null;

      if (!entity) {
        const apiEntity = await AV.AVEntity.get(mainOwner);
        if (apiEntity) {
          entityDataList?.push(apiEntity);
          dispatch(setEntitydata(entityDataList));
          entity = apiEntity as { staff?: AV.IStaff[] };
        }
      }

      // 2. Staff Role Check (Owner / Staff)
      if (entity?.staff) {
        staff = entity.staff;
      }

      if (staff) {
        ownerFlag = staff.some(
          (x) =>
            x?.id === currentUser?.id &&
            (x?.role.name === "Owner" || x?.role.name === "Staff"),
        );
      }

      //// If staff-based ownership is confirmed
      //if (ownerFlag) {
      //  setIsOwnerOfBoost(true);
      //  setBoostPostCreditsOwner(AV.AVEntity.getFk(mainOwner));
      //  return;
      //}

      // 3. Direct Ownership Check
      if (item?.owner?.type === "Person" || item?.owner?.type === "Pet") {
        ownerFlag =
          item?.owner?.id === currentUser?.id ||
          item?.person?.id === currentUser?.id;
      } else if (isEventOrChannel) {
        ownerFlag = item?.topOwner?.id === entity?.id;
      }

      // If NOT owner → exit early
      if (!ownerFlag) {
        setIsOwnerOfBoost(false);
        return;
      }

      // 4. Check Share Permission
      const canShare = await checkShareTypeCase(mainOwner);

      if (!canShare) {
        setIsOwnerOfBoost(false);
        return;
      }

      // 5. Final success
      setIsOwnerOfBoost(true);
      setBoostPostCreditsOwner(AV.AVEntity.getFk(mainOwner));
    };

    checkBoostOwner();
  }, [item]);

  // RichTextEditor(Formatting Post)
  const editorRef = useRef<SunEditorCore | null>(null);
  const [useRichText, setUseRichText] = useState(item?.ptype === "H");
  const [rteValue, setRteValue] = useState("");
  const customFonts = [
    "Arial",
    "Calibri",
    "Cambria",
    "Candara",
    "Comic Sans MS",
    "Consolas",
    "Constantia",
    "Corbel",
    "Courier New",
    "Georgia",
    "Impact",
    "Lucida Console",
    "Lucida Sans Unicode",
    "Palatino Linotype",
    "Segoe Print",
    "Segoe Script",
    "Segoe UI",
    "Tahoma",
    "Times New Roman",
    "Trebuchet MS",
    "Verdana",
  ];
  const toolbarOptions = {
    buttonList: [
      ["font", "fontSize"],
      ["fontColor", "hiliteColor"],
      ["bold", "italic", "underline", "strike"],
      ["align", "list"],
      ["link", "image"],
      ["undo", "redo"],
    ],
    showPathLabel: false,
    //resizingBar: false,
    defaultStyle: "font-family: Arial; font-size: 16px;",
    placeholder: Loc.currentLang.postPopup.shareWhatIsOnYourMind,
    font: customFonts,
    fontSize: [8, 10, 12, 14, 16, 18, 20, 24, 28, 32, 64, 128],
  };

  const [bgColor, setBgColor] = useState<string>("");
  const [bgImage, setBgImage] = useState<string>("");
  const [bgImgWidth, setBgImgWidth] = useState<string>("");
  const [bgImgHeight, setBgImgHeight] = useState<string>("");
  const [showBgImgMenu, setShowBgImgMenu] = useState(false);
  const [showColorPicker, setShowColorPicker] = useState(false);
  const colorInputRef = useRef<HTMLInputElement | null>(null);
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const editorContainerRef = useRef<HTMLDivElement | null>(null);
  const colorPickerRef = useRef<HTMLDivElement | null>(null);
  const bgImgMenuRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (
        colorPickerRef.current &&
        !colorPickerRef.current.contains(e.target as Node)
      ) {
        setShowColorPicker(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        bgImgMenuRef.current &&
        !bgImgMenuRef.current.contains(event.target as Node)
      ) {
        setShowBgImgMenu(false);
        setShowColorPicker(false);
      }
    };

    if (showBgImgMenu) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showBgImgMenu]);

  useEffect(() => {
    if (
      editorRef.current &&
      useRichText &&
      item?.ptype === "H" &&
      item?.text?.length > 0
    ) {
      const cleanHTML = item.text.replace(
        /<figure[^>]*>(.*?)<\/figure>/g,
        "$1",
      );

      editorRef.current.setContents(cleanHTML);
      setRteValue(cleanHTML);

      // Delay DOM manipulation until SunEditor finishes rendering content
      setTimeout(() => {
        const div = document.createElement("div");
        div.innerHTML = cleanHTML;

        const wrapper = div.querySelector("div[style]") as HTMLElement | null;
        const editableArea = document.querySelector<HTMLDivElement>(
          ".sun-editor-editable",
        );

        if (!editableArea) return;

        // Reset background and size
        editableArea.style.backgroundColor = "unset";
        editableArea.style.backgroundImage = "unset";
        editableArea.style.backgroundSize = "unset";
        editableArea.style.backgroundPosition = "unset";
        editableArea.style.backgroundRepeat = "unset";
        editableArea.style.height = isExpanded ? "54vh" : "20vh";
        editableArea.style.minHeight = isExpanded ? "54vh" : "20vh";
        editableArea.style.width = "unset";
        editableArea.style.minWidth = "unset";

        let imgWidth = "";
        let imgHeight = "";

        if (wrapper) {
          const bgColorMatch = wrapper.style.backgroundColor;
          const bgImageMatch = wrapper.style.backgroundImage
            ?.replace(/url\(["']?(.+?)["']?\)/, "$1")
            ?.trim();

          imgWidth = wrapper.style.width;
          imgHeight = wrapper.style.height;
          setBgImgWidth(imgWidth);
          setBgImgHeight(imgHeight);

          const hasBgColorInHTML =
            wrapper.style.backgroundColor &&
            wrapper.style.backgroundColor !== "transparent" &&
            wrapper.style.backgroundColor !== "unset" &&
            wrapper.style.backgroundColor !== "none";

          const hasBgImageInHTML =
            wrapper.style.backgroundImage &&
            wrapper.style.backgroundImage !== "none" &&
            wrapper.style.backgroundImage !== "unset";

          // Background color
          if (!hasBgColorInHTML && (bgColorMatch || bgColor)) {
            const finalColor = bgColor?.length > 0 ? bgColor : bgColorMatch;
            editableArea.style.backgroundColor = finalColor || "unset";
            setBgColor(finalColor || "");
            setBgImage("");
            setBgImgWidth("");
            setBgImgHeight("");
          } else if (hasBgColorInHTML) {
            editableArea.style.backgroundColor = wrapper.style.backgroundColor;
            setBgColor(wrapper.style.backgroundColor);
            setBgImage("");
            setBgImgWidth("");
            setBgImgHeight("");
          }

          // Background image
          if (!hasBgImageInHTML && (bgImageMatch || bgImage)) {
            const finalImage = bgImage?.length > 0 ? bgImage : bgImageMatch;

            editableArea.style.backgroundImage = `url(${finalImage})`;
            editableArea.style.backgroundSize = "contain";
            editableArea.style.backgroundPosition = "left";
            editableArea.style.backgroundRepeat = "no-repeat";
            setBgImage(finalImage);
            setBgColor("");
          } else if (hasBgImageInHTML) {
            const imgUrl = wrapper.style.backgroundImage.replace(
              /url\(["']?(.+?)["']?\)/,
              "$1",
            );

            editableArea.style.backgroundImage = `url(${imgUrl})`;
            editableArea.style.backgroundSize = "contain";
            editableArea.style.backgroundPosition = "left";
            editableArea.style.backgroundRepeat = "no-repeat";
            setBgImage(imgUrl);
            setBgColor("");
          }
        }

        // Apply width/height after DOM render is stable
        if (imgHeight && imgWidth) {
          editableArea.style.height = imgHeight;
          editableArea.style.minHeight = imgHeight;
          editableArea.style.width = imgWidth;
          editableArea.style.minWidth = imgWidth;
        } else {
          editableArea.style.height = isExpanded ? "54vh" : "20vh";
        }
      }, 100); // small delay ensures the editor is ready
    }
  }, [item]);

  useEffect(() => {
    if (editorRef.current && useRichText) {
      const editableArea = document.querySelector<HTMLDivElement>(
        ".sun-editor-editable",
      );

      if (editableArea) {
        if (bgImgHeight && bgImgWidth) {
          editableArea.style.height = `${bgImgHeight}px`;
          editableArea.style.minHeight = `${bgImgHeight}px`;
          editableArea.style.width = `${bgImgWidth}px`;
          editableArea.style.minWidth = `${bgImgWidth}px`;
        } else {
          editableArea.style.height = isExpanded ? "54vh" : "20vh";
        }
      }
    }
  }, [isExpanded]);

  useEffect(() => {
    if (editorRef.current && useRichText && bgColor.trim().length > 0) {
      const editableArea = document.querySelector<HTMLDivElement>(
        ".sun-editor-editable",
      );

      if (editableArea) {
        editableArea.innerHTML = editableArea.innerHTML
          .replace(/background-color:\s*#[0-9A-Fa-f]{3,6};?/g, "")
          .replace(/<div[^>]*>([\s\S]*?)<\/div>/g, "$1");

        editableArea.style.backgroundImage = "unset";
        editableArea.style.backgroundSize = "unset";
        editableArea.style.backgroundPosition = "unset";
        editableArea.style.backgroundRepeat = "unset";
        editableArea.style.height = isExpanded ? "54vh" : "20vh";
        editableArea.style.minHeight = isExpanded ? "54vh" : "20vh";
        editableArea.style.width = "unset";
        editableArea.style.minWidth = "unset";

        editableArea.style.backgroundColor = bgColor;
      }
    }
  }, [isOpenCemera, showExternalLinkInput]);

  const handleColorChange = (color: any) => {
    setBgImage("");
    setBgImgWidth("");
    setBgImgHeight("");
    setBgColor(color.hex);

    const editableArea = document.querySelector<HTMLDivElement>(
      ".sun-editor-editable",
    );
    if (editableArea) {
      editableArea.innerHTML = editableArea.innerHTML
        .replace(/background-color:\s*#[0-9A-Fa-f]{3,6};?/g, "")
        .replace(/<div[^>]*>([\s\S]*?)<\/div>/g, "$1");

      editableArea.style.backgroundImage = "unset";
      editableArea.style.backgroundSize = "unset";
      editableArea.style.backgroundPosition = "unset";
      editableArea.style.backgroundRepeat = "unset";
      editableArea.style.height = isExpanded ? "54vh" : "20vh";
      editableArea.style.minHeight = isExpanded ? "54vh" : "20vh";
      editableArea.style.width = "unset";
      editableArea.style.minWidth = "unset";

      editableArea.style.backgroundColor = color.hex;
    }
  };

  const handleToggleRichTextPost = () => {
    setUseRichText((prev) => {
      const newValue = !prev;
      //if (!showBoostPostPopup) handleToggleRichTextSubject();

      setTimeout(() => {
        if (newValue) {
          // Switching TO Rich Text
          if (text && !/<[a-z][\s\S]*>/i.test(text)) {
            const formattedText = `<p>${text}</p>`;
            setRteValue(formattedText);

            const editor = editorRef.current;
            if (editor) {
              editor.setContents(formattedText);
              const editableArea = editor.core?.context?.element?.wysiwyg;
              if (editableArea && !showBoostPostPopup) {
                const range = document.createRange();
                const selection = window.getSelection();
                range.selectNodeContents(editableArea);
                range.collapse(false); // move cursor to end
                selection?.removeAllRanges();
                selection?.addRange(range);
              }
            }
          }
        } else {
          // Switching TO Plain Text
          const tempDiv = document.createElement("div");
          tempDiv.innerHTML = rteValue;
          const plain = (tempDiv.innerText || "")
            .trim()
            .replace(/[\u200B-\u200D\uFEFF]/g, "");
          setText(plain);

          //// Move cursor to end in textarea
          //setTimeout(() => {
          //  if (textRef.current) {
          //    const textarea = textRef.current;
          //    textarea.focus();
          //    textarea.selectionStart =
          //      textarea.selectionEnd =
          //        textarea.value.length;
          //  }
          //}, 100);

          // Remove backgroundImage and backgroundColor
          setBgColor("");
          setBgImage("");
          setBgImgWidth("");
          setBgImgHeight("");

          const editableArea = document.querySelector<HTMLDivElement>(
            ".sun-editor-editable",
          );
          if (editableArea) {
            editableArea.style.backgroundImage = "unset";
            editableArea.style.backgroundSize = "unset";
            editableArea.style.backgroundPosition = "unset";
            editableArea.style.backgroundRepeat = "unset";
            editableArea.style.backgroundColor = "unset";

            editableArea.style.height = isExpanded ? "54vh" : "20vh";
            editableArea.style.minHeight = isExpanded ? "54vh" : "20vh";
            editableArea.style.width = "unset";
            editableArea.style.minWidth = "unset";
          }
        }
      }, 200); // small delay for render sync

      return newValue;
    });
  };

  const handleToggleRichTextSubject = () => {
    setUseRichText((prev) => {
      const newValue = !prev;
      if (showBoostPostPopup) handleToggleRichTextPost();

      setTimeout(() => {
        if (newValue) {
          // Switching TO Rich Text
          if (subject && !/<[a-z][\s\S]*>/i.test(subject)) {
            const formattedText = `<p>${subject}</p>`;
            setSubject(formattedText);

            const editor = editorRef.current;
            if (editor) {
              editor.setContents(formattedText);
              const editableArea = editor.core?.context?.element?.wysiwyg;
              if (editableArea) {
                const range = document.createRange();
                const selection = window.getSelection();
                range.selectNodeContents(editableArea);
                range.collapse(false); // move cursor to end
                selection?.removeAllRanges();
                selection?.addRange(range);
              }
            }
          }
        } else {
          // Switching TO Plain Text
          const tempDiv = document.createElement("div");
          tempDiv.innerHTML = subject;
          const plain = (tempDiv.innerText || "")
            .trim()
            .replace(/[\u200B-\u200D\uFEFF]/g, "");
          setSubject(plain);

          // Remove backgroundImage and backgroundColor
          setBgColor("");
          setBgImage("");
          setBgImgWidth("");
          setBgImgHeight("");

          const editableArea = document.querySelector<HTMLDivElement>(
            ".sun-editor-editable",
          );
          if (editableArea) {
            editableArea.style.backgroundImage = "unset";
            editableArea.style.backgroundSize = "unset";
            editableArea.style.backgroundPosition = "unset";
            editableArea.style.backgroundRepeat = "unset";
            editableArea.style.backgroundColor = "unset";
            editableArea.style.width = "unset";
            editableArea.style.minWidth = "unset";
          }
        }
      }, 200); // small delay for render sync

      return newValue;
    });
  };

  // camera
  const [cameraMode, setCameraMode] = useState<"photo" | "video">("photo");
  const [recording, setRecording] = useState(false);
  const [duration, setDuration] = useState(0);
  const recordedChunksRef = useRef<Blob[]>([]);
  const webcamRef = useRef<Webcam | null>(null);
  const mediaRecorderRef = useRef<MediaRecorder | null>(null);
  const durationRef = useRef<number | null>(null);
  const isCancelledRef = useRef(false);

  const formatDuration = (seconds: number) => {
    const m = Math.floor(seconds / 60)
      .toString()
      .padStart(2, "0");
    const s = (seconds % 60).toString().padStart(2, "0");
    return `${m}:${s}`;
  };

  useEffect(() => {
    if (recording) {
      durationRef.current = window.setInterval(() => {
        setDuration((prev) => prev + 1);
      }, 1000);
    } else {
      if (durationRef.current !== null) clearInterval(durationRef.current);
      setDuration(0);
    }

    return () => {
      if (durationRef.current !== null) clearInterval(durationRef.current);
    };
  }, [recording]);

  const handleImages = async (e: any) => {
    const fileInput: any = imageInputRef.current;
    let files: any = Array.from(e?.target?.files);

    const updatedFiles = files.map((file: any) => {
      const fileName = file.name;
      if (fileName.toLowerCase().endsWith(".jfif")) {
        const updatedFileName = fileName.replace(/\.\w+$/, ".jpg");
        const updatedFile = new File([file], updatedFileName, {
          type: "image/jpeg",
        });
        return updatedFile;
      } else {
        return file;
      }
    });
    files = updatedFiles;

    let m = "";
    if (files.length > 20) {
      m = Loc.currentLang.postPopup.youCannotUploadMoreThan20FilesPerPost;
      setAlertMessage(m);
      return;
    }

    files.forEach((img: any) => {
      if (
        img.type !== "image/jpeg" &&
        img.type !== "image/jfif" &&
        img.type !== "image/png" &&
        /*img.type !== "image/webp" &&*/
        img.type !== "image/gif" &&
        img.type !== "video/mp4" &&
        img.type !== "video/quicktime" &&
        img.type !== "audio/mpeg"
      ) {
        files = files.filter((item: any) => item.name !== img.name);
        m =
          Loc.currentLang.postPopup
            .formatIsUnsupportedOnlyJpegJfifPngWebpGifAreAllowed;
        setAlertMessage(m);
        return;
      } else {
        const reader = new FileReader();
        reader.readAsDataURL(img);
        reader.onload = (readerEvent) => {
          /*setImages((images) => [...images, readerEvent.target.result]);*/
        };
      }
    });

    console.log(files);
    setIsImageProcessing(true);

    if (files?.length > 0) {
      const data = await AV.Media.saveFiles(
        AV.Media.getFormData(files),
        currentUser?.region,
      );

      if (data[0]?.status == "Invalid Size") {
        setAlertMessage(Loc.currentLang.alertMessages.largeVideo);
        setIsImageProcessing(false);
        fileInput.value = null;

        return;
      }

      setMedia((prev) => [...prev, ...data]);

      data?.forEach((img) => {
        if (img.type.startsWith("image")) {
          setImages((images) => [...images, img]);
        } else if (img.type.startsWith("application")) {
          setDocs((images) => [...images, img]);
        } else setvideos((videos) => [...videos, img]);
      });
    }

    setIsImageProcessing(false);
    fileInput.value = null;
  };

  // Replace all base64 images in HTML with uploaded URLs
  async function replaceBase64WithLinks(
    html: string,
    region: string,
  ): Promise<string> {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    const imgTags = tempDiv.querySelectorAll("img");

    for (const img of imgTags) {
      const src = img.getAttribute("src");
      const imgStyle = img.getAttribute("style") || "";

      // Process only valid Base64 images
      if (!src || !src.startsWith("data:image")) continue;

      // Convert Base64 to File
      const file = base64ToFile2(src, "upload-image.jpg");
      if (!file) continue;

      // Convert to FileList
      const fileList = createFileList([file]);

      // Upload file
      const data = await AV.Media.saveFiles(
        AV.Media.getFormData(fileList),
        region,
      );
      if (!data || data.length === 0) continue;

      // Get uploaded link
      const srclink = AV.Media.getURL(data[0]);
      if (!srclink) continue;

      // Set metadata before saving
      data[0].parent = AV.AVEntity.getFk(item?.owner ?? AV.Person.self());
      //data[0].linkURL = srclink;

      // Save uploaded media
      await AV.Media.saveMedia(data);

      // Replace Base64 src with actual URL
      img.setAttribute("src", srclink);

      // Determine image width dynamically
      const tempImage = document.createElement("img");
      tempImage.src = src;

      await new Promise<void>((resolve) => {
        tempImage.onload = () => {
          // Extract width and height from style (if any)
          const widthMatch = imgStyle.match(/width:\s*(\d+)px/i);
          const heightMatch = imgStyle.match(/height:\s*(\d+)px/i);

          let styleWidth = widthMatch ? parseInt(widthMatch[1], 10) : undefined;
          let styleHeight = heightMatch
            ? parseInt(heightMatch[1], 10)
            : undefined;

          // Fallback to actual image size if no style width/height
          const width = styleWidth ?? tempImage.width;
          const height = styleHeight ?? tempImage.height;

          //// Apply max width constraint
          //const finalWidth = width > 775 ? 775 : width;
          //const finalHeight = height;

          //// Set final styles
          //img.setAttribute(
          //  "style",
          //  `width: ${finalWidth}px; height: ${finalHeight}px;`,
          //);

          resolve();
        };

        tempImage.onerror = () => resolve();
      });
    }

    return tempDiv.innerHTML;
  }

  const handleUpdatePost = async (e: any) => {
    let reloading = null;
    setIsLoading(true);

    let media: any = [];
    images?.forEach((ele) => {
      media.push(ele);
    });
    videos?.forEach((ele) => {
      media.push(ele);
    });
    docs.forEach((ele) => {
      media.push(ele);
    });
    links.forEach((ele) => {
      media.push(ele);
    });
    oneDriveLink.forEach((ele) => {
      media.push(ele);
    });
    media = _.uniqBy(media, "id");
    e.preventDefault();

    let gallery = { layout: null, Items: [] };
    let galleryArray: any = [];
    item.gallery = gallery;
    const originalText = useRichText ? item.text : item.text;

    let textContent = useRichText ? rteValue.trim() : text;
    let subContent = subject || "";

    if (useRichText) {
      // Replace base64 images with uploaded links
      textContent = await replaceBase64WithLinks(
        textContent,
        currentUser?.region,
      );

      // Remove previous wrapper div with background styles
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = textContent;

      // If the top element is a div with inline style, unwrap it
      const firstChild = tempDiv.firstElementChild as HTMLElement | null;
      if (
        firstChild &&
        firstChild.tagName === "DIV" &&
        (firstChild.style.backgroundColor || firstChild.style.backgroundImage)
      ) {
        textContent = firstChild.innerHTML; // unwrap inner content
      }

      // Wrap content with the current background color/image
      if (bgColor || bgImage) {
        textContent = `<div style="
          ${bgColor ? `background-color: ${bgColor};` : ""}
          ${
            bgImage
              ? `
            background-image: url(${bgImage});
            background-size: contain;
            background-position: left;
            background-repeat: no-repeat;
            width: ${bgImgWidth ? `${bgImgWidth}px` : "auto"};
            height: ${bgImgHeight ? `${bgImgHeight}px` : "auto"};
          `
              : ""
          }
        ">${textContent}</div>`;
      }

      // Subject image
      subContent = await replaceBase64WithLinks(
        subContent,
        currentUser?.region,
      );

      //const tempSubDiv = document.createElement("div");
      //tempSubDiv.innerHTML = subContent;

      //const firstSubChild = tempSubDiv.firstElementChild as HTMLElement | null;
      //if (
      //  firstSubChild &&
      //  firstSubChild.tagName === "DIV" &&
      //  (firstSubChild.style.backgroundColor ||
      //    firstSubChild.style.backgroundImage)
      //) {
      //  subContent = firstSubChild.innerHTML;
      //}
    }
    item.text = textContent;
    item.ptype = useRichText ? "H" : null;
    item.paySend = textContent?.trim()?.length ? paySend : null;
    item.subject = textContent?.trim()?.length && paySend > 0 ? subject : null;

    //item.owner = AV.AVEntity.getFk(item.owner);
    item.visibility = visibilityMap[visibility];
    if (!item?.media || media.length === 0) item.media = null;

    //// Attach metadata (parent + linkURL)
    //for (const mediaItem of media) {
    //  const srclink = AV.Media.getURL(mediaItem);
    //  if (!srclink) continue;
    //  mediaItem.parent =AV.AVEntity.getFk(item.owner);
    //  mediaItem.linkURL = srclink;
    //}

    if (media && media.length === 1) {
      item.media = media[0];
    }

    if (media && media.length > 1) {
      let galleryPost: any = [];
      item.media = null;
      for (var i = 0; i < media.length; i++) {
        let galleryPostlist: any = item.galleryPost?.filter(
          (x) => x.media.id == media[i].id,
        );
        if (galleryPostlist?.length === 0 || galleryPostlist === undefined) {
          let param1: AV.IFeedParam = {
            feed: AVBase.getFk(item.owner),
            startDate: new Date(0),
            forward: true,
          };
          if (param1?.feed?.id) {
            let post1: any = {
              pk: param1?.feed?.id,
              region: param1?.feed?.region,
            };
            post1.visibility = visibilityMap[visibility];
            post1.parentPost = item.id;
            post1.owner = AV.AVEntity.getFk(item.owner);
            post1.visibility = visibility == visibilityMap[visibility];
            post1.media = media[i];
            post1.ptype = "G";
            let childresponse = await Post.save(post1);
            if (childresponse === Loc.currentLang.menu.inappropriateErrorMsg) {
              let clientError = {
                message: Loc.currentLang.menu.inappropriateErrorMsg,
              };
              CustomToast({ clientError });
              setIsLoading(false);
              item.text = originalText;
              return;
            }

            dispatch(setisActive(true));
            galleryArray.push(childresponse.id);
            galleryPost.push(childresponse);
          }
        } else {
          galleryArray.push(
            item.galleryPost?.filter((x) => x.media.id == media[i].id)[0].id,
          );
          galleryPost.push(
            item.galleryPost?.filter((x) => x.media.id == media[i].id)[0],
          );
        }
      }

      item.gallery.Items = galleryArray;
      item.galleryPost = [];
      let val: any = await AV.Post.save(item);
      if (val === Loc.currentLang.menu.inappropriateErrorMsg) {
        let clientError = {
          message: Loc.currentLang.menu.inappropriateErrorMsg,
        };
        CustomToast({ clientError });
        setIsLoading(false);
        item.text = originalText;
        return;
      }

      dispatch(setisActive(true));
      item.galleryPost = galleryPost;
      val.galleryPost = galleryPost;
      if (item?.children?.length > 0) val.children = item.children;
      if (item?.impressions?.length > 0) val.impressions = item.impressions;
      await FeedsUpdate(val);
      setIsLoading(false);
      setSuccessMessage(Loc.currentLang.postPopup.yourPostHasBeenPublished);
      setShowCreatePost(false);
      dispatch(setPostPopupExpanded(false));

      if (paySend > 0 && boostPostCreditsOwner?.id) {
        setTimeout(() => {
          creditsUpdateAfterPublish();
        }, 500);
      }

      setPaySend(0);
      setSubject("");
      setEstimate(0);

      return;
    }

    let val: any = await AV.Post.save(item);
    if (val === Loc.currentLang.menu.inappropriateErrorMsg) {
      let clientError = { message: Loc.currentLang.menu.inappropriateErrorMsg };
      CustomToast({ clientError });
      setIsLoading(false);
      item.text = originalText;
      return;
    }

    dispatch(setisActive(true));
    if (val) {
      if (item?.children?.length > 0 ? true : false)
        val.children = item.children;
      if (item?.impressions?.length > 0 ? true : false)
        val.impressions = item.impressions;
      if (
        val?.galleryPost?.length == 0 ||
        val?.galleryPost?.length == undefined ||
        val?.media?.id?.trim()?.length == 0 ||
        val?.media?.id?.trim()?.length == undefined
      ) {
        setShowDetails(false);
        setpreviewitem([]);
      }
      setItem(val);
      let feeds = userFeeds.filter((x) => x.id == val.id);
      if (feeds?.length > 0) {
        await FeedsUpdate(val);
      } else {
        const updatedParentPost = await replaceChildrenInParent(
          val?.id,
          val?.parentPost,
          userFeeds,
          val,
        );
        let exciting = userFeeds?.filter((x) => x.id == updatedParentPost?.id);
        userFeeds[userFeeds.indexOf(exciting[0])] = updatedParentPost;
        let exciting1 = feedChunks?.filter(
          (x) => x.id == updatedParentPost?.id,
        );
        feedChunks[feedChunks.indexOf(exciting1[0])] = updatedParentPost;
        dispatch(setFeeds(userFeeds));
        setFeedChunks(feedChunks);
        setMedia([]);
        setIsLoading(false);
        setSuccessMessage(Loc.currentLang.postPopup.yourPostHasBeenPublished);
        setShowCreatePost(false);
        dispatch(setPostPopupExpanded(false));

        if (paySend > 0 && boostPostCreditsOwner?.id) {
          setTimeout(() => {
            creditsUpdateAfterPublish();
          }, 500);
        }

        setPaySend(0);
        setSubject("");
        setEstimate(0);

        return;
      }
    }
    setMedia([]);
    setIsLoading(false);
    setSuccessMessage(Loc.currentLang.postPopup.yourPostHasBeenPublished);
    setShowCreatePost(false);
    dispatch(setPostPopupExpanded(false));

    if (paySend > 0 && boostPostCreditsOwner?.id) {
      setTimeout(() => {
        creditsUpdateAfterPublish();
      }, 500);
    }

    setPaySend(0);
    setSubject("");
    setEstimate(0);
  };

  const FeedsUpdate = async (val) => {
    setItem({ ...val });

    const matchedUserFeed = userFeeds.find((x) => x.id === val.id);
    const matchedFeedChunk = feedChunks.find((x) => x.id === val.id);

    if (matchedUserFeed) {
      const index = userFeeds.indexOf(matchedUserFeed);
      userFeeds[index] = val;
    }

    if (matchedFeedChunk) {
      const index = feedChunks.indexOf(matchedFeedChunk);
      feedChunks[index] = val;
    } else {
      const updatedParentPost = await replaceChildrenInParent(
        val?.id,
        val?.parentPost,
        userFeeds,
        val,
      );

      const matchedParentInUserFeed = userFeeds.find(
        (x) => x.id === updatedParentPost?.id,
      );
      if (matchedParentInUserFeed) {
        const index = userFeeds.indexOf(matchedParentInUserFeed);
        userFeeds[index] = updatedParentPost;
      }

      const matchedParentInFeedChunk = feedChunks.find(
        (x) => x.id === updatedParentPost?.id,
      );
      if (matchedParentInFeedChunk) {
        const index = feedChunks.indexOf(matchedParentInFeedChunk);
        feedChunks[index] = updatedParentPost;
      }
    }

    dispatch(setFeeds([...userFeeds]));
    setFeedChunks([...feedChunks]);
    dispatch(setFeedsUpdate(true));
  };

  const replaceChildrenInParent = (
    postId,
    parentpostId,
    nestedData,
    newChildren,
  ) => {
    for (const item of nestedData) {
      if (item.id === parentpostId) {
        if (!item?.children) item.children = [];
        let val = item.children.filter((x) => x?.id == postId);
        if (val?.length > 0)
          item.children[item.children.indexOf(val[0])] = newChildren;
        else item.children.push(newChildren);
        return item;
      }

      if (item.children && item.children.length > 0) {
        // Continue searching in children
        const updatedChild = replaceChildrenInParent(
          postId,
          parentpostId,
          item.children,
          newChildren,
        );
        if (updatedChild) {
          return item; // Return the parent with updated children
        }
      }
      if (item?.galleryPost && item.galleryPost.length > 0) {
        // Continue searching in children
        const updatedChild = replaceChildrenInParent(
          postId,
          parentpostId,
          item.galleryPost,
          newChildren,
        );
        if (updatedChild) {
          return item; // Return the parent with updated children
        }
      }
    }
    return null; // Parent post not found
  };

  const creditsUpdateAfterPublish = async () => {
    const entity: any =
      item?.owner?.type === "Event" ||
      item?.owner?.type === "Game" ||
      item?.owner?.type === "Channel"
        ? item?.topOwner
        : (item?.owner ?? currentUser);
    const fk: AV.IFK = AV.AVEntity.getFk(entity ?? currentUser);
    let finalFk: AV.IFK = fk; //item?.owner ?? fk;
    if (item?.owner?.type === "Person") {
      finalFk =
        currentUser?.id !== item?.owner.id
          ? AV.AVEntity.getFk(currentUser)
          : item?.owner;
    }

    // Update current user credits
    if (
      finalFk?.id === currentUser?.id &&
      currentUser?.plan &&
      !currentUser?.plan?.shared
    ) {
      dispatch(
        setUser({
          ...currentUser,
          plan: {
            ...currentUser.plan,
            credits: (currentUser.plan.credits || 0) - (estimate ?? 0),
          },
        }),
      );
    }

    // Shared Plan
    if (sharedPlan && sharedPlan?.plan) {
      setSharedPlan?.({
        ...sharedPlan,
        plan: {
          ...sharedPlan.plan,
          credits: (sharedPlan.plan.credits || 0) - (estimate ?? 0),
        },
      });

      const updatedList = [...entityDataList];
      const index = updatedList.findIndex((x) => x?.id === sharedPlan?.id);

      if (index !== -1) {
        const current = updatedList[index];

        updatedList[index] = {
          ...current,
          plan: {
            ...current?.plan,
            credits: (current?.plan?.credits || 0) - (estimate ?? 0),
          },
        };
      }

      dispatch(setEntitydata(updatedList));
    }

    // Update entity list credits
    if (
      finalFk?.id === currentUser?.id &&
      currentUser?.plan &&
      !currentUser?.plan?.shared
    ) {
      const updatedList = [...entityDataList];
      const index = updatedList.findIndex((x) => x?.id === currentUser?.id);

      if (index !== -1) {
        const current = updatedList[index];

        updatedList[index] = {
          ...current,
          plan: {
            ...current?.plan,
            credits: (current?.plan?.credits || 0) - (estimate ?? 0),
          },
        };
      }

      dispatch(setEntitydata(updatedList));
    }

    //if (!boostPostCreditsOwner?.id) return;

    //try {
    //  const entityDataAPI: AV.IAVEntity | null = await AV.AVEntity.get(
    //    boostPostCreditsOwner,
    //  );

    //  if (entityDataAPI) {
    //    if (entityDataAPI.type === "Person") {
    //      dispatch(setUser(entityDataAPI));
    //    }

    //    const index = entityDataList?.findIndex(
    //      (x) => x?.id === entityDataAPI.id,
    //    );
    //    if (index !== -1) {
    //      entityDataList[index] = entityDataAPI;
    //    } else {
    //      entityDataList?.push(entityDataAPI);
    //    }

    //    dispatch(setEntitydata([...entityDataList]));
    //  }
    //} catch (e) {
    //  console.error("Failed to update entity after publish:", e);
    //}
  };

  const handleEmojiPicker = (e: any) => {
    const emoji = e?.native;

    // Insert emoji into RTE
    if (useRichText && editorRef.current) {
      editorRef.current.insertHTML(emoji);
    } else {
      // Insert emoji into plain text input
      const ref: any = textEditRef.current;
      if (!ref) return;

      ref.focus();

      const start = text?.substring(0, ref.selectionStart) || "";
      const end = text?.substring(ref.selectionStart) || "";
      const newText = start + emoji + end;

      setText(newText);
      const cursor = start.length + emoji.length;
      ref.setSelectionRange(cursor, cursor);
    }

    setPicker(false); // close picker
  };

  const apiCall = async (url) => {
    try {
      const response = await axios.get("https://api.linkpreview.net", {
        params: {
          key: "fa7a7a675495a6cc97dac00c791ddb6b",
          q: url,
        },
      });
      // Check if response data exists
      if (response.data) {
        return response.data;
      } else {
        throw new Error("No data returned from API");
      }
    } catch (error) {
      setAddLinkLoad(false);
      setExternalLink("");
      setShowExternalLinkInput(false);
      setIsImageProcessing(false);
      let clientError = { message: "Invalid link format." };
      CustomToast({ clientError }); // Display error message using CustomToast
      console.error("Error fetching URL preview:", error);
      // Handle error appropriately (you could return a default value, throw error, etc.)
      throw new Error("Failed to fetch data from the API");
    }
  };

  function convertToEmbedLink(shareLink) {
    const url = new URL(shareLink);

    // Extract the video ID from the share link
    const videoId = url.pathname.split("/")[1];

    // Extract query parameters
    const queryParams = url.search;

    // Construct the embed link
    return `https://www.youtube.com/embed/${videoId}${queryParams}`;
  }

  const HandleAddLinkToMedia = async () => {
    setAlertMessage("");
    setIsOpenBox(false);
    setAddLinkLoad(true);
    setIsImageProcessing(true);
    //let newLink = externalLink;
    let getExternalLinkType = isYoutube ? "iframe" : "linkPreview";
    let linkOfYoutube = "";
    if (!isValidLink?.test(externalLink)) {
      let clientError = { message: "Invalid link format." };
      CustomToast({ clientError }); // Display error message using CustomToast
      setAddLinkLoad(false);
      setExternalLink("");
      setShowExternalLinkInput(false);
      return; // Exit the function early if the link format is invalid
    }
    let fd = new FormData();
    fd.append("linkURL", externalLink);
    const data = await AV.Media.saveFiles(fd, currentUser?.region);
    let response = await apiCall(externalLink);
    if (isYoutube) {
      linkOfYoutube = await convertToEmbedLink(externalLink);
    }
    data[0].linkURL = isYoutube ? linkOfYoutube : externalLink;
    data[0].orgFile =
      response?.image?.trim()?.length > 0
        ? response?.image
        : "https://cdn.pixabay.com/photo/2022/01/11/21/48/link-6931554_1280.png";
    data[0].type = getExternalLinkType;
    setMedia((prev) => [...prev, ...data]);
    //post.media = data[ 0 ];
    if (data?.length > 0) {
      data.forEach((img) => {
        setLinks((link) => [...link, img]);
      });
    }
    setAddLinkLoad(false);
    setExternalLink("");
    setShowExternalLinkInput(false);
    setIsImageProcessing(false);
  };

  useEffect(() => {
    console.log("useEffect isOnedriveData data:", isOnedriveData);
    let isMounted = true;

    const run = async () => {
      if (isOnedriveData?.blob !== undefined && isMounted) {
        await HandleAddOneDrive();
      }
    };

    run();

    return () => {
      isMounted = false;
    };
  }, [isOnedriveData]);

  const menuRefs = useRef(null);
  useOutsideAlerter(menuRefs);

  function useOutsideAlerter(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setIsActive(false);
          setPicker(false);
          setIsOpenBox(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  const handleExternalLink = (e) => {
    setExternalLink(e.target.value);
  };

  const handleOpenPicker = () => {
    openPicker({
      clientId:
        "143407568263-uh85ecaqapgumtq787b2m3mu0l1sm0ve.apps.googleusercontent.com",
      developerKey: "AIzaSyCgz1ryXdQ2aDugOM1-dNHuz1Pavi1n230",
      viewId: "DOCS",
      // token: token, // pass oauth token in case you already have one
      showUploadView: true,
      showUploadFolders: true,
      supportDrives: true,
      multiselect: true,
      // customViews: customViewsArray, // custom view
      callbackFunction: (data) => {
        if (data.action === "cancel") {
          console.log("User clicked cancel/close button");
        }
        if (data?.action !== "loaded") {
          HandleAddDocsLink(data?.docs);
        }
      },
    });
  };

  const HandleAddDocsLink = async (link) => {
    setIsOpenBox(false);
    setAddLinkLoad(true);
    setIsImageProcessing(true);
    for (let i = 0; i < link?.length; i++) {
      if (!isValidLink?.test(link[i]?.embedUrl)) {
        let clientError = { message: "Invalid link format." };
        CustomToast({ clientError }); // Display error message using CustomToast
        setAddLinkLoad(false);
        setExternalLink("");
        setShowExternalLinkInput(false);
        return; // Exit the function early if the link format is invalid
      }
      let fd = new FormData();
      fd.append("linkURL", link[i]?.embedUrl);
      const data = await AV.Media.saveFiles(fd, currentUser?.region);
      data[0].linkURL = link[i]?.embedUrl;
      data[0].orgFile = link[i]?.mimeType.startsWith("image")
        ? "GoogleDrive.jpg"
        : "GoogleDrive.mp4";
      data[0].type = "iframe";
      setMedia((prev) => [...prev, ...data]);
      setAllMedia((prev) => [...prev, ...data]);
      //post.media = data[ 0 ];
      if (data?.length > 0) {
        data.forEach((img) => {
          setOneDriveLink((oneDriveLink) => [...oneDriveLink, img]);
        });
      }
    }
    setAddLinkLoad(false);
    setShowExternalLinkInput(false);
    setIsImageProcessing(false);
  };

  function base64ToFile2(base64: string, filename: string): File {
    const arr = base64.split(",");
    const mime = arr[0].match(/:(.*?);/)?.[1] || "";
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  }

  // Utility to convert File[] to FileList
  function createFileList(files: File[]): FileList {
    const dataTransfer = new DataTransfer();
    files.forEach((file) => dataTransfer.items.add(file));
    return dataTransfer.files;
  }

  const handleCameraPhotoCapture = async () => {
    setAlertMessage("");
    setIsOpenCemera(false);

    if (!webcamRef.current) {
      console.error("Webcam not available");
      return;
    }

    const imageSrc = webcamRef.current.getScreenshot();
    if (!imageSrc) {
      console.error("Failed to capture image from webcam");
      return;
    }

    let file = base64ToFile2(imageSrc, "captured-image.jpg");

    // Limit file count
    const files: File[] = [file];
    if (files.length > 20) {
      const m =
        Loc.currentLang?.alertMessages?.maxUploadFiles ||
        Loc.currentLang?.postPopup?.youCannotUploadMoreThan20FilesPerPost;
      setAlertMessage(m);
      return;
    }

    // UI State
    setPicker(false);
    setIsImageProcessing(true);

    // Preview file
    const reader = new FileReader();
    //reader.onload = (e) => {
    //  setImages((prev) => [...prev, e.target?.result]);
    //};
    reader.readAsDataURL(file);

    try {
      const fileList = createFileList(files);
      const data = await AV.Media.saveFiles(
        AV.Media.getFormData(fileList),
        currentUser?.region,
      );

      if (data?.length > 0) {
        setMedia((prev) => [...prev, ...data]);

        data.forEach((item) => {
          setImages((prev) => [...prev, item]);
        });
      }
    } catch (error) {
      console.error("Upload failed:", error);
      setAlertMessage("Upload failed. Please try again.");
    } finally {
      setIsImageProcessing(false);
      onClose();
    }
  };

  const handleCameraVideoCapture = async (chunks: Blob[]) => {
    setAlertMessage("");
    setIsOpenCemera(false);

    const blob = new Blob(chunks, { type: "video/webm" });
    const file = new File([blob], "recorded-video.webm", {
      type: "video/webm",
    });

    const files: File[] = [file];
    if (files.length > 20) {
      const m =
        Loc.currentLang?.alertMessages?.maxUploadFiles ||
        Loc.currentLang?.postPopup?.youCannotUploadMoreThan20FilesPerPost;
      setAlertMessage(m);
      return;
    }

    setPicker(false);
    setIsImageProcessing(true);

    const reader = new FileReader();
    //reader.onload = (e) => {
    //  setvideos((prev) => [...prev, e.target?.result]);
    //};
    reader.readAsDataURL(file);

    try {
      const fileList = createFileList(files);
      const data = await AV.Media.saveFiles(
        AV.Media.getFormData(fileList),
        currentUser?.region,
      );

      if (data?.length > 0) {
        setMedia((prev) => [...prev, ...data]);

        data.forEach((item) => {
          setvideos((prev) => [...prev, item]);
        });
      }
    } catch (error) {
      console.error("Upload failed:", error);
      setAlertMessage("Upload failed. Please try again.");
    } finally {
      if (mediaRecorderRef.current) {
        mediaRecorderRef.current.stop();
        setRecording(false);
      }
      setIsImageProcessing(false);
      onClose();
    }
  };

  const handleStartRecording = () => {
    setAlertMessage("");
    recordedChunksRef.current = [];

    const stream = webcamRef.current?.stream;

    if (!stream) {
      console.error("Webcam stream not available");
      return;
    }

    const mediaRecorder = new MediaRecorder(stream, {
      mimeType: "video/webm; codecs=vp9",
    });

    mediaRecorder.ondataavailable = (event) => {
      if (event.data.size > 0) {
        recordedChunksRef.current.push(event.data);
      }
    };

    mediaRecorder.onstop = () => {
      if (!isCancelledRef.current) {
        handleCameraVideoCapture(recordedChunksRef.current);
      } else {
        isCancelledRef.current = false; // reset flag for future recordings
      }
    };

    mediaRecorderRef.current = mediaRecorder;
    mediaRecorder.start();
    setRecording(true);
  };

  const handleStopRecording = () => {
    if (mediaRecorderRef.current) {
      mediaRecorderRef.current.stop();
      setRecording(false);
    }
  };

  const toggleMode = () => {
    if (recording) {
      isCancelledRef.current = true; // mark that we're switching mode and canceling recording
      handleStopRecording();
    }

    setCameraMode((prev) => (prev === "photo" ? "video" : "photo"));
  };

  const onClose = () => {
    setIsOpenCemera(false);
    setRecording(false);
    setDuration(0);
    setCameraMode("photo");
    if (durationRef.current !== null) clearInterval(durationRef.current);
  };

  const HandleAddOneDrive = async () => {
    setAlertMessage("");
    setIsOpenBox(false);
    setAddLinkLoad(true);
    setIsImageProcessing(true);

    console.log("isOnedriveData data:", isOnedriveData);
    const mimeType = isOnedriveData?.type;
    const validTypes = [
      "image/jpeg",
      "image/jfif",
      "image/png",
      /*"image/webp",*/
      "image/gif",
      "video/mp4",
      "video/quicktime",
    ];

    if (!validTypes.includes(mimeType)) {
      let m =
        Loc.currentLang.postPopup
          .formatIsUnsupportedOnlyJpegJfifPngWebpGifAreAllowed;
      setAddLinkLoad(false);
      setIsImageProcessing(false);
      setShowExternalLinkInput(false);
      setAlertMessage(m);
      return;
    }

    // Append the file blob
    const fd = new FormData();
    fd.append("file", isOnedriveData?.blob, isOnedriveData?.name);

    try {
      console.log("Form data: ", fd);
      const data = await AV.Media.saveFiles(fd, currentUser?.region);
      console.log("API response: ", data);

      if (data?.length > 0) {
        setMedia((prev) => [...prev, ...data]);
        data?.forEach((img) => {
          if (img.type.startsWith("image")) {
            setImages((images) => [...images, img]);
          } else if (img.type.startsWith("application")) {
            setDocs((images) => [...images, img]);
          } else setvideos((videos) => [...videos, img]);
        });
      }
    } catch (err) {
      console.error("Error uploading to API", err);
      CustomToast({ clientError: { message: "Upload failed" } });
    }

    setAddLinkLoad(false);
    setShowExternalLinkInput(false);
    setIsImageProcessing(false);
    setIsOneDriveData("");
  };

  const HandleAddDropBoxLink = async (link) => {
    setIsOpenBox(false);
    setAddLinkLoad(true);
    setIsImageProcessing(true);
    for (let i = 0; i < link?.length; i++) {
      if (!isValidLink?.test(link[i]?.thumbnailLink)) {
        let clientError = { message: "Invalid link format." };
        CustomToast({ clientError }); // Display error message using CustomToast
        setAddLinkLoad(false);
        setExternalLink("");
        setShowExternalLinkInput(false);
        return; // Exit the function early if the link format is invalid
      }
      let fd = new FormData();
      fd.append("linkURL", link[i]?.thumbnailLink);
      const data = await AV.Media.saveFiles(fd, currentUser?.region);
      data[0].linkURL = link[i]?.link;
      data[0].orgFile = link[i]?.thumbnailLink;
      data[0].type = "dropbox";
      setMedia((prev) => [...prev, ...data]);
      setAllMedia((prev) => [...prev, ...data]);
      //post.media = data[ 0 ];
      if (data?.length > 0) {
        data.forEach((img) => {
          setOneDriveLink((oneDriveLink) => [...oneDriveLink, img]);
        });
      }
    }
    setAddLinkLoad(false);
    setShowExternalLinkInput(false);
    setIsImageProcessing(false);
  };

  useEffect(() => {
    let img: any = [];
    let videoUrl: any = [];
    let docsUrl: any = [];
    let linkUrl: any = [];
    let onedriveUrl: any = [];
    if (item?.media?.type?.startsWith("image") && !item?.media?.linkURL)
      img.push(item.media);
    else if (item?.media?.type?.startsWith("video") && !item?.media?.linkURL)
      videoUrl.push(item.media);
    else if (
      (item?.media?.type?.startsWith("application") ||
        item?.media?.type?.startsWith("text/plain")) &&
      !item?.media?.linkURL
    )
      docsUrl.push(item.media);
    else if (
      item?.media?.linkURL &&
      (item?.media?.type == "iframe" || item?.media?.type == "linkPreview")
    )
      linkUrl?.push(item.media);
    else if (
      item?.media?.linkURL &&
      item?.media?.type !== "iframe" &&
      item?.media?.type !== "linkPreview"
    )
      onedriveUrl?.push(item.media);
    item?.galleryPost?.map((item1) => {
      if (item1?.media?.type?.startsWith("image") && !item1?.media?.linkURL)
        img.push(item1.media);
      else if (
        item1?.media?.type?.startsWith("video") &&
        !item1?.media?.linkURL
      )
        videoUrl.push(item1.media);
      else if (
        item1?.media?.type?.startsWith("application") &&
        !item1?.media?.linkURL
      )
        docsUrl.push(item1.media);
      else if (
        item1?.media?.linkURL &&
        (item1?.media?.type == "iframe" || item1?.media?.type == "linkPreview")
      )
        linkUrl?.push(item1.media);
      else if (
        item1?.media?.linkURL &&
        item1?.media?.type !== "iframe" &&
        item1?.media?.type !== "linkPreview"
      )
        onedriveUrl?.push(item1.media);
    });
    let MergedData = [...img, ...docsUrl];
    setImages(MergedData);
    setvideos(videoUrl);
    setDocs(docsUrl);
    setOneDriveLink(onedriveUrl);
    setLinks(linkUrl);
    let MediaAll = [...img, ...videoUrl, ...docsUrl, ...linkUrl];
    setAllMedia(MediaAll);

    setPaySend?.(item?.paySend);
    setSubject?.(item?.subject);
    setUseRichText?.(item?.ptype === "H");
  }, []);

  useEffect(() => {
    if (textEditRef.current && !isTrue) {
      textEditRef.current.focus();
      textEditRef.current.setSelectionRange(text?.length, text?.length);
    }
    setIsTrue(true);
  }, [showModal]);

  useEffect(() => {
    let isMounted = true;

    async function checkCameraAccess() {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          video: true,
        });
        if (isMounted) {
          setIsCameraAccessible(true);
        }
        stream.getTracks().forEach((track) => track.stop());
      } catch (err) {
        if (isMounted) {
          setIsCameraAccessible(false);
        }
      }
    }

    if (isOpenCemera) {
      checkCameraAccess();
    }

    return () => {
      isMounted = false;
    };
  }, [isOpenCemera]);

  const hasContent = (html: string) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html || "";

    let text = tempDiv.textContent || "";
    text = text.replace(/[\u200B-\u200D\uFEFF]/g, "").trim();
    if (text.length > 0) return true; // has real text

    // Check if HTML contains <img> or <video> tags
    if (tempDiv.querySelector("img, video")) return true;

    return false;
  };

  const handleConfirmDelete = (item) => {
    setIsConfirmDelete(true);
    setConfirmationText(
      Loc.currentLang.confirmationText.areYouSureYouWantToRemoveThisItem,
    );
    setSelectedItem(item);
    setSelectedType("PostImageRemove");
  };

  const handleCancelImage = () => {
    setIsLoading(true);

    const filterById = (list) =>
      list?.filter((f) => f.id !== selectedItem.id) ?? [];

    setMedia(filterById(media));
    setImages(filterById(images));
    setvideos(filterById(videos));
    setOneDriveLink(filterById(oneDriveLink));
    setAllMedia(filterById(allMedia));
    setLinks(filterById(links));

    setIsLoading(false);
    setSelectedItem("");
    setSelectedType("");
    setConfirmationText("");
    setIsConfirmDelete(false);
  };

  const dropdownRef = useRef(null);
  useOutsideDropdownRef(dropdownRef, isActive, setIsActive);

  function useOutsideDropdownRef(ref, isActive, setIsActive) {
    useEffect(() => {
      const handleClickOutside = (event) => {
        if (ref.current && !ref.current.contains(event.target)) {
          setIsActive(false);
        }
      };

      if (isActive) {
        document.addEventListener("mousedown", handleClickOutside);
      }

      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref, isActive, setIsActive]);
  }

  return (
    <>
      {!showExternalLinkInput && (
        <Box
          position={"fixed"}
          top={0}
          bottom={0}
          left={0}
          right={0}
          bgColor={"rgba(0, 0, 0, 0.25)"}
          zIndex={99999}
        >
          <div
            className={`create_post_popup ${
              mobile && "create_post_popup_mobile"
            }`}
            style={{
              width: isExpanded
                ? mobile
                  ? "100%"
                  : "90%"
                : mobile
                  ? dimensions.width - 15
                  : "700px",
              height: isExpanded ? (mobile ? "100%" : "90vh") : "60vh",
              maxHeight: isExpanded ? (mobile ? "100%" : "90vh") : "60vh",
              padding: isExpanded ? "30px" : "24px",
              top: isExpanded ? "50%" : "55%",
            }}
          >
            {picker && (
              <Box
                position={"absolute"}
                ref={menuRefs}
                zIndex={99}
                borderColor={"#2FA3BE"}
                borderStyle={"solid"}
                borderWidth={"5px"}
                width={mobile ? "85%" : "88%%"}
              >
                <AVEmojiPicker onEmojiSelect={(e) => handleEmojiPicker(e)} />
              </Box>
            )}

            <VStack height={"100%"}>
              <HStack alignItems={"center"} justifyContent={"space-between"}>
                <Text fontSize={24}>
                  {" "}
                  {item?.parentPost
                    ? Loc.currentLang.post.editComment
                    : Loc.currentLang.post.editPost}
                </Text>

                <HStack space={3} alignItems="center">
                  {/* Expand / Collapse Button */}
                  <Tooltip
                    title={
                      isExpanded
                        ? Loc.currentLang.postPopup.collapse
                        : Loc.currentLang.postPopup.expand
                    }
                    style={{ top: "4px", zIndex: 10 }}
                    arrow
                  >
                    <Pressable
                      onPress={() => {
                        setIsExpanded((prev) => !prev);
                        dispatch(setPostPopupExpanded((prev) => !prev));
                      }}
                    >
                      {isExpanded ? <CollapseIcon /> : <ExpandIcon />}
                    </Pressable>
                  </Tooltip>

                  {/* Close Button */}
                  <AVCancel
                    callback={() => {
                      setShowCreatePost(false);
                      dispatch(setPostPopupExpanded(false));
                    }}
                    color={undefined}
                    size={undefined}
                  />
                </HStack>
              </HStack>

              <ScrollView
                showsHorizontalScrollIndicator={false}
                maxHeight={isExpanded ? "78vh" : "45vh"}
              >
                <HStack
                  marginTop={"0px"}
                  space={3}
                  alignItems="center"
                  justifyContent="space-between"
                >
                  {/* Who Can View */}
                  {item?.parentPost === undefined && !isHuddlePostTab ? (
                    <HStack marginTop={"30px"} space={3}>
                      <Text fontSize={"18"}>
                        {Loc.currentLang.menu.whoCanView}:
                      </Text>
                      <HStack ref={menuRefs}>
                        <HStack>
                          <Button
                            width={"248px"}
                            bgColor={"rgba(0, 166, 188, 0.15)"}
                            rounded="full"
                            fontWeight="550px"
                            color="#fff"
                            justifyContent={"flex-start"}
                            minHeight="40px"
                            marginTop={"-5px"}
                            borderRadius={"20px"}
                            borderColor={"AVColor.primary"}
                            onPress={() => {
                              setIsActive(!isActive);
                            }}
                          >
                            <Text
                              color={"rgba(0, 167, 188, 1)"}
                              font-size={"18px"}
                              lineHeight={"1rem"}
                              paddingLeft={"18px"}
                            >
                              {visibility}
                            </Text>
                          </Button>
                          <Pressable
                            position={"absolute"}
                            right={"12px"}
                            top={"10px"}
                            onPress={() => {
                              setIsActive(!isActive);
                            }}
                          >
                            <DropdownIcon height={"9"} width={"16"} />
                          </Pressable>
                        </HStack>

                        <HStack ref={dropdownRef}>
                          {isActive && (
                            <HStack
                              position={"absolute"}
                              right={0}
                              top={"39px"}
                              flexDirection={"column"}
                              width={"240px"}
                              borderRadius={"5px"}
                              bgColor="#FFFFFF"
                              shadow="9"
                              rounded="lg"
                              zIndex={100}
                            >
                              <Button
                                onPress={() => {
                                  item.visibility = "Private";
                                  setVisibility(Loc.currentLang.menu.private);
                                  setIsActive(!isActive);
                                }}
                                bgColor="#FFFFFF"
                                height="30px"
                                justifyContent={"start"}
                                _hover={{
                                  backgroundColor: "AVColor.hovercolor",
                                }}
                                width={"240px"}
                              >
                                <Text color={"black"}>
                                  {Loc.currentLang.menu.private}
                                </Text>
                              </Button>

                              <Button
                                onPress={() => {
                                  item.visibility = "Public";
                                  setVisibility(Loc.currentLang.menu.public);
                                  setIsActive(!isActive);
                                }}
                                bgColor="#FFFFFF"
                                height="30px"
                                justifyContent={"start"}
                                _hover={{
                                  backgroundColor: "AVColor.hovercolor",
                                }}
                                width={"240px"}
                              >
                                <Text color={"black"}>
                                  {Loc.currentLang.menu.public}
                                </Text>
                              </Button>

                              <Button
                                onPress={() => {
                                  item.visibility = "Followers";
                                  setVisibility(Loc.currentLang.menu.followers);
                                  setIsActive(!isActive);
                                }}
                                bgColor="#FFFFFF"
                                height="30px"
                                justifyContent={"start"}
                                _hover={{
                                  backgroundColor: "AVColor.hovercolor",
                                }}
                                width={"240px"}
                              >
                                <Text color={"black"}>
                                  {Loc.currentLang.menu.followers}
                                </Text>
                              </Button>

                              {(visibility === "Organizations" ||
                                isstaffOfEntity ||
                                (item?.owner?.type !== "Person" &&
                                  item?.owner?.type !== "Event" &&
                                  item?.owner?.type !== "Game" &&
                                  item?.owner?.type !== "Channel")) && (
                                <Button
                                  onPress={() => {
                                    item.visibility = "Org";
                                    setVisibility(
                                      Loc.currentLang.menu.organizations,
                                    );
                                    setIsActive(!isActive);
                                  }}
                                  bgColor="#FFFFFF"
                                  height="30px"
                                  justifyContent={"start"}
                                  _hover={{
                                    backgroundColor: "AVColor.hovercolor",
                                  }}
                                  width={"240px"}
                                >
                                  <Text color={"black"}>
                                    {Loc.currentLang.menu.organizations}
                                  </Text>
                                </Button>
                              )}
                            </HStack>
                          )}
                        </HStack>
                      </HStack>
                    </HStack>
                  ) : (
                    <Box width="300px" />
                  )}

                  {/* Right Side — Boost Post */}
                  {!item?.parentPost &&
                    /*isstaffOfEntity || */ isOwnerOfBoost && (
                      <HStack mt="30px" space={3} alignItems="center">
                        <Pressable onPress={() => setShowBoostPostPopup(true)}>
                          <HStack alignItems="center" space={2}>
                            <BoostIcon width={"24px"} height={"24px"} />
                            <Text
                              fontSize="20px"
                              color="#00A7BC"
                              textDecorationLine="underline"
                            >
                              {Loc.currentLang.boostPost.boostPost}
                            </Text>
                          </HStack>
                        </Pressable>
                      </HStack>
                    )}
                </HStack>

                <div style={{ position: !isActive ? "relative" : "unset" }}>
                  <Box
                    marginTop={"24px"}
                    height={
                      bgImgHeight
                        ? `${Math.min((parseInt(bgImgHeight, 10) / window.innerHeight) * 100 + 7, 61)}vh`
                        : isExpanded
                          ? "61vh"
                          : "27vh"
                    }
                    maxHeight={isExpanded ? "61vh" : "27vh"}
                    overflowY={useRichText ? "auto" : "unset"}
                    overflowX="hidden"
                    borderWidth={useRichText ? 0 : 1}
                    borderRadius={useRichText ? 0 : 5}
                    borderColor={"AVColor.grey"}
                    zIndex={isActive ? "-1" : "0"}
                    position="relative"
                  >
                    {useRichText ? (
                      <SunEditor
                        getSunEditorInstance={(editor) => {
                          editorRef.current = editor;

                          const editorContainer =
                            document.querySelector(".sun-editor");
                          if (!editorContainer) return;

                          // HARD BLOCK drag & drop
                          const wysiwyg = editor.core.context.element.wysiwyg;
                          if (!wysiwyg) return;

                          ["dragenter", "dragover", "drop"].forEach((event) => {
                            wysiwyg.addEventListener(
                              event,
                              (e) => {
                                e.preventDefault();
                                e.stopPropagation();
                              },
                              true,
                            );
                          });

                          // Helper: clear image dialog state
                          const clearImageDialogState = () => {
                            const fileInput = document.querySelector(
                              "._se_image_file",
                            ) as HTMLInputElement | null;

                            if (fileInput) {
                              fileInput.value = "";
                            }

                            const statusText = document.querySelector(
                              ".file-status-text",
                            ) as HTMLElement | null;

                            if (statusText) {
                              statusText.textContent =
                                Loc.currentLang.richText.noFileChosen;
                              statusText.style.color = "#777";
                            }

                            const imageUrlInput = document.querySelector(
                              "._se_image_url",
                            ) as HTMLInputElement | null;

                            if (imageUrlInput) imageUrlInput.value = "";

                            const urlError = document.querySelector(
                              ".image-url-error",
                            ) as HTMLElement | null;

                            if (urlError) urlError.style.display = "none";
                          };

                          // Watch for the Image Insert dialog opening
                          const observer = new MutationObserver(() => {
                            // Image dialog
                            const imageDialog = document.querySelector(
                              ".se-dialog-image",
                            ) as HTMLElement | null;

                            if (!imageDialog) return;

                            // Custom File Input validation handling
                            const fileInput = document.querySelector(
                              "._se_image_file",
                            ) as HTMLInputElement;
                            if (
                              fileInput &&
                              !fileInput.parentElement?.querySelector(
                                ".file-status",
                              )
                            ) {
                              // Allow only JPG + PNG + GIF
                              fileInput.accept =
                                "image/jpeg, image/png, image/gif";
                              // Add dashed border style
                              const fileContainer = fileInput.closest(
                                ".se-dialog-form-files",
                              ) as HTMLElement;
                              if (fileContainer) {
                                fileContainer.style.position = "relative";
                                fileContainer.style.border = "2px dashed #ccc";
                                fileContainer.style.borderRadius = "8px";
                                fileContainer.style.padding = "12px";
                                fileContainer.style.textAlign = "center";
                              }

                              // Create wrapper for labels
                              const statusDiv = document.createElement("div");
                              statusDiv.className = "file-status";
                              statusDiv.innerHTML = `
                                <span class="upload-label">${Loc.currentLang.richText.uploadFile}</span>
                                <span class="file-status-text">${Loc.currentLang.richText.noFileChosen}</span>
                              `;
                              fileInput.parentElement?.appendChild(statusDiv);

                              // Handle file change event
                              fileInput.addEventListener(
                                "change",
                                (e: Event) => {
                                  const target = e.target as HTMLInputElement;
                                  const file = target?.files?.[0] || null;
                                  const statusText = statusDiv.querySelector(
                                    ".file-status-text",
                                  ) as HTMLElement;

                                  // Clear Image URL when file is uploaded
                                  const imageUrlInput =
                                    imageDialog.querySelector(
                                      "._se_image_url",
                                    ) as HTMLInputElement | null;

                                  const urlError = imageDialog.querySelector(
                                    ".image-url-error",
                                  ) as HTMLElement | null;

                                  const submitBtn = imageDialog.querySelector(
                                    ".se-btn-primary",
                                  ) as HTMLButtonElement | null;

                                  if (imageUrlInput) imageUrlInput.value = "";
                                  if (urlError) urlError.style.display = "none";
                                  if (submitBtn) submitBtn.disabled = false;

                                  if (file) {
                                    if (
                                      ![
                                        "image/jpeg",
                                        "image/png",
                                        "image/gif",
                                      ].includes(file.type)
                                    ) {
                                      statusText.textContent =
                                        "Only JPEG, PNG and GIF files are allowed";
                                      statusText.style.color = "red";
                                      target.value = ""; // Reset invalid file
                                      return;
                                    }

                                    statusText.textContent = file.name;
                                    statusText.style.color = "#333";
                                  } else {
                                    statusText.textContent =
                                      Loc.currentLang.richText.noFileChosen;
                                    statusText.style.color = "#777";
                                  }
                                },
                              );

                              // Custom Image URL validation handling
                              const imageUrlInput = imageDialog.querySelector(
                                "._se_image_url",
                              ) as HTMLInputElement | null;
                              const submitBtn = imageDialog.querySelector(
                                ".se-btn-primary",
                              ) as HTMLButtonElement | null;

                              if (imageUrlInput && submitBtn) {
                                let errorMsg = imageDialog.querySelector(
                                  ".image-url-error",
                                ) as HTMLElement | null;
                                if (!errorMsg) {
                                  errorMsg = document.createElement("div");
                                  errorMsg.className = "image-url-error";
                                  errorMsg.style.color = "red";
                                  errorMsg.style.fontSize = "12px";
                                  errorMsg.style.marginTop = "6px";
                                  errorMsg.style.display = "none";
                                  imageUrlInput.parentElement?.appendChild(
                                    errorMsg,
                                  );
                                }

                                if (!(imageUrlInput as any)._boundValidation) {
                                  (imageUrlInput as any)._boundValidation =
                                    true;

                                  imageUrlInput.addEventListener(
                                    "input",
                                    () => {
                                      const value = imageUrlInput.value.trim();

                                      if (!value) {
                                        errorMsg!.style.display = "none";
                                        submitBtn.disabled = false;
                                        return;
                                      }

                                      if (!isValidLink.test(value)) {
                                        errorMsg!.textContent =
                                          "Enter a valid image URL";
                                        errorMsg!.style.display = "block";
                                        submitBtn.disabled = true;
                                      } else {
                                        errorMsg!.style.display = "none";
                                        submitBtn.disabled = false;
                                      }
                                    },
                                  );
                                }
                              }

                              // Handle image dialog close
                              const closeBtn = imageDialog.querySelector(
                                'button[data-command="close"]',
                              ) as HTMLButtonElement | null;

                              if (closeBtn && !(closeBtn as any)._boundClear) {
                                (closeBtn as any)._boundClear = true;
                                closeBtn.addEventListener(
                                  "click",
                                  clearImageDialogState,
                                );
                              }

                              // Handle image clear on submit
                              if (
                                submitBtn &&
                                !(submitBtn as any)._boundSubmitClear
                              ) {
                                (submitBtn as any)._boundSubmitClear = true;
                                submitBtn.addEventListener("click", () => {
                                  setTimeout(clearImageDialogState, 300);
                                });
                              }
                            }
                          });

                          // Observe editor container for dialogs being added
                          observer.observe(editorContainer, {
                            childList: true,
                            subtree: true,
                          });
                        }}
                        lang={
                          currentUser?.preferences?.lang
                            ? currentUser.preferences.lang === "en-us"
                              ? "en"
                              : currentUser.preferences.lang
                            : "en"
                        }
                        setOptions={{
                          ...toolbarOptions,
                          height: isExpanded ? "54vh" : "20vh",
                        }}
                        onChange={(newContent) => setRteValue(newContent)}
                        defaultValue={rteValue} // initial value only
                        autoFocus={true}
                      />
                    ) : (
                      <textarea
                        ref={textEditRef}
                        value={text}
                        maxLength={1000}
                        style={{
                          border: "none",
                          resize: "none",
                          height: isExpanded ? "55vh" : "20vh",
                          padding: "20px 15px",
                          outline: "none",
                          fontFamily: "inherit",
                          fontSize: "inherit",
                          borderColor: "rgba(0, 0, 0, 0.25)",
                        }}
                        placeholder={Loc.currentLang.post.createPostPlaceholder}
                        onChange={(e) => setText(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === "Enter" && !e.shiftKey && !isMobile) {
                            e.preventDefault();
                            handleUpdatePost(e);
                          }
                        }}
                        autoFocus
                      />
                    )}

                    {/* Right-side Buttons (Top editor tool options Background Controls) */}
                    {useRichText && (
                      <div
                        style={{
                          position: "absolute",
                          //right: isExpanded ? "calc(100% - 685px)" : "10px",
                          right: isExpanded ? "calc(100% - 655px)" : "45px",
                          top: "5px",
                          display: "flex",
                          flexDirection: "row",
                          gap: "10px",
                          border: "1px solid #dadada",
                          borderRadius: "4px",
                          //padding: isExpanded ? "4px 6px" : "4px 5px",
                          padding: "8px 8px",
                          zIndex: 10,
                        }}
                      >
                        {/* Background Color Picker */}
                        <Box
                          position="relative"
                          display="inline-block"
                          //top="3px"
                        >
                          <Tooltip
                            title={Loc.currentLang.postPopup.backgroundColor}
                            arrow
                          >
                            <Pressable
                              onPress={() =>
                                setShowColorPicker(!showColorPicker)
                              }
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <BrushIcon height="20" width="20" color="black" />
                            </Pressable>
                          </Tooltip>

                          {/* Color picker popup */}
                          {showColorPicker && (
                            <div
                              style={{
                                position: "absolute",
                                bottom: isExpanded ? "40px" : "auto",
                                top: "40px",
                                right: "20px",
                                zIndex: 9999,
                                maxHeight: isExpanded ? "auto" : "150px",
                                overflowY: isExpanded ? "visible" : "auto",
                              }}
                              ref={colorPickerRef}
                            >
                              <Box
                                display="flex"
                                flexDirection="column"
                                alignItems="center"
                                justifyContent="center"
                              >
                                {/* Color Picker */}
                                <SketchPicker
                                  color={bgColor}
                                  onChange={handleColorChange}
                                />

                                {/* Remove background color */}
                                {bgColor && (
                                  <Tooltip
                                    title={
                                      Loc.currentLang.postPopup
                                        .removeBackgroundColor
                                    }
                                    arrow
                                  >
                                    <Pressable
                                      alignSelf="flex-end"
                                      top="-25px"
                                      left="-14px"
                                      onPress={() => {
                                        setBgColor("");
                                        const editableArea =
                                          document.querySelector<HTMLDivElement>(
                                            ".sun-editor-editable",
                                          );
                                        if (editableArea)
                                          editableArea.style.backgroundColor =
                                            "unset";
                                        setShowColorPicker(false);
                                      }}
                                    >
                                      <CircleSlashIcon
                                        width={"14px"}
                                        height={"14px"}
                                      />
                                    </Pressable>
                                  </Tooltip>
                                )}
                              </Box>
                            </div>
                          )}
                        </Box>

                        {/* Background Image Upload + Add/Remove Menu */}
                        {/*<Box position="relative" display="inline-block">*/}
                        {/*  <input*/}
                        {/*    type="file"*/}
                        {/*    accept="image/*"*/}
                        {/*    ref={(el) => (fileInputRef.current = el)}*/}
                        {/*    onChange={async (e) => {*/}
                        {/*      const file = e.target.files?.[0];*/}
                        {/*      if (!file) return;*/}

                        {/*      const fileList = createFileList([file]);*/}
                        {/*      if (!fileList) return;*/}

                        {/*      try {*/}
                        {/*        const data = await AV.Media.saveFiles(*/}
                        {/*          AV.Media.getFormData(fileList),*/}
                        {/*          currentUser?.region,*/}
                        {/*        );*/}

                        {/*        setBgColor("");*/}
                        {/*        const srclink = AV.Media.getURL(data[0]);*/}
                        {/*        setBgImage(srclink);*/}

                        {/*        const editableArea =*/}
                        {/*          document.querySelector<HTMLDivElement>(*/}
                        {/*            ".sun-editor-editable",*/}
                        {/*          );*/}
                        {/*        if (editableArea) {*/}
                        {/*          // Create an image object to get its natural width and height*/}
                        {/*          const img = document.createElement(*/}
                        {/*            "img",*/}
                        {/*          ) as HTMLImageElement;*/}
                        {/*          img.src = srclink;*/}

                        {/*          img.onload = () => {*/}
                        {/*            const imgWidth = img.naturalWidth;*/}
                        {/*            const imgHeight = img.naturalHeight;*/}
                        {/*            setBgImgWidth(imgWidth.toString());*/}
                        {/*            setBgImgHeight(imgHeight.toString());*/}

                        {/*            // Set editor background*/}
                        {/*            editableArea.style.backgroundColor =*/}
                        {/*              "unset";*/}
                        {/*            editableArea.style.backgroundImage = `url(${srclink})`;*/}
                        {/*            editableArea.style.backgroundSize =*/}
                        {/*              "contain";*/}
                        {/*            editableArea.style.backgroundPosition =*/}
                        {/*              "left";*/}
                        {/*            editableArea.style.backgroundRepeat =*/}
                        {/*              "no-repeat";*/}

                        {/*            // Set editor height to image height or scale as needed*/}
                        {/*            editableArea.style.height = `${imgHeight}px`;*/}
                        {/*            editableArea.style.minHeight = `${imgHeight}px`;*/}
                        {/*            editableArea.style.width = `${imgWidth}px`;*/}
                        {/*            editableArea.style.minWidth = `${imgWidth}px`;*/}
                        {/*          };*/}
                        {/*        }*/}
                        {/*      } catch (err) {*/}
                        {/*        console.error(*/}
                        {/*          "Background image upload failed:",*/}
                        {/*          err,*/}
                        {/*        );*/}
                        {/*      }*/}
                        {/*    }}*/}
                        {/*    style={{ display: "none" }}*/}
                        {/*  />*/}

                        {/*  */}
                        {/* Background Image Options */}
                        {/*  <Tooltip title={Loc.currentLang.postPopup.backgroundImage} arrow>*/}
                        {/*    <Pressable*/}
                        {/*      onPress={() => {*/}
                        {/*        if (bgImage) setShowBgImgMenu(!showBgImgMenu);*/}
                        {/*        else fileInputRef.current?.click();*/}
                        {/*      }}*/}
                        {/*      style={{*/}
                        {/*        display: "flex",*/}
                        {/*        alignItems: "center",*/}
                        {/*        justifyContent: "center",*/}
                        {/*      }}*/}
                        {/*    >*/}
                        {/*      <ImportBGImage*/}
                        {/*        height="28"*/}
                        {/*        width="28"*/}
                        {/*        color="black"*/}
                        {/*      />*/}
                        {/*    </Pressable>*/}
                        {/*  </Tooltip>*/}

                        {/*  */}
                        {/* Menu List for Add/Remove */}
                        {/*  {showBgImgMenu && (*/}
                        {/*    <Box*/}
                        {/*      ref={bgImgMenuRef}*/}
                        {/*      position="absolute"*/}
                        {/*      top="40px"*/}
                        {/*      right="0"*/}
                        {/*      bg="white"*/}
                        {/*      borderWidth="1px"*/}
                        {/*      borderColor="#ddd"*/}
                        {/*      borderRadius="8px"*/}
                        {/*      shadow={3}*/}
                        {/*      zIndex={9999}*/}
                        {/*      p="2px"*/}
                        {/*      minW="70px"*/}
                        {/*    >*/}
                        {/*      <Pressable*/}
                        {/*        onPress={() => {*/}
                        {/*          fileInputRef.current?.click();*/}
                        {/*          setShowBgImgMenu(false);*/}
                        {/*        }}*/}
                        {/*      >*/}
                        {/*        <Box px={3} py={2}>*/}
                        {/*          <Text fontSize="14px">{Loc.currentLang.postPopup.add}</Text>*/}
                        {/*        </Box>*/}
                        {/*      </Pressable>*/}

                        {/*      <Pressable*/}
                        {/*        onPress={() => {*/}
                        {/*          setBgImage("");*/}
                        {/*          setBgImgWidth("");*/}
                        {/*          setBgImgHeight("");*/}

                        {/*          const editableArea =*/}
                        {/*            document.querySelector<HTMLDivElement>(*/}
                        {/*              ".sun-editor-editable",*/}
                        {/*            );*/}
                        {/*          if (editableArea) {*/}
                        {/*            editableArea.style.backgroundImage =*/}
                        {/*              "unset";*/}
                        {/*            editableArea.style.backgroundSize = "unset";*/}
                        {/*            editableArea.style.backgroundPosition =*/}
                        {/*              "unset";*/}
                        {/*            editableArea.style.backgroundRepeat =*/}
                        {/*              "unset";*/}

                        {/*            editableArea.style.height = isExpanded*/}
                        {/*              ? "54vh"*/}
                        {/*              : "20vh";*/}
                        {/*            editableArea.style.minHeight = isExpanded*/}
                        {/*              ? "54vh"*/}
                        {/*              : "20vh";*/}
                        {/*            editableArea.style.width = "unset";*/}
                        {/*            editableArea.style.minWidth = "unset";*/}
                        {/*          }*/}

                        {/*          setShowBgImgMenu(false);*/}
                        {/*        }}*/}
                        {/*      >*/}
                        {/*        <Box px={3} py={2}>*/}
                        {/*          <Text fontSize="14px" color="red.500">*/}
                        {/*            { Loc.currentLang.postPopup.remove }*/}
                        {/*          </Text>*/}
                        {/*        </Box>*/}
                        {/*      </Pressable>*/}
                        {/*    </Box>*/}
                        {/*  )}*/}
                        {/*</Box>*/}
                      </div>
                    )}

                    {/* Right-side Buttons (Bottom Formatting + Emoji) */}
                    <div
                      style={{
                        position: "absolute",
                        right: "10px",
                        bottom: "10px",
                        display: "flex",
                        flexDirection: "row",
                        gap: "10px",
                        zIndex: 10,
                        alignItems: "center",
                      }}
                    >
                      {/* Formatting Icon */}
                      <Tooltip
                        title={
                          useRichText
                            ? Loc.currentLang.postPopup.plainPost
                            : Loc.currentLang.postPopup.formattingPost
                        }
                        style={{ top: "0px", zIndex: 10 }}
                        arrow
                      >
                        <Pressable onPress={handleToggleRichTextPost}>
                          {useRichText ? <PlainTextIcon /> : <FormattingIcon />}
                        </Pressable>
                      </Tooltip>

                      {/* Emoji Icon */}
                      <AVEmoji showEmoji={() => setPicker((prev) => !prev)} />
                    </div>
                  </Box>

                  <HStack
                    my={3}
                    justifyContent={"center"}
                    width={isExpanded ? (mobile ? "100%" : "85%") : "85%"}
                    //height={isExpanded ? (mobile ? "200px" : "250px") : "auto"}
                    space={4}
                    alignItems={"center"}
                    alignSelf={"center"}
                    zIndex={useRichText ? "-3" : "0"}
                  >
                    <CreatePostGrid
                      setLinks={setLinks}
                      links={links}
                      images={images}
                      setImages={setImages}
                      setvideos={setvideos}
                      allMedia={allMedia}
                      setAllMedia={setAllMedia}
                      videos={videos}
                      setOneDriveLink={setOneDriveLink}
                      oneDriveLink={oneDriveLink}
                      setMedia={setMedia}
                      media={media}
                      pdf={pdf}
                      setpdf={setpdf}
                      setShowPreview={setShowPreview}
                      setSingleImage={setSingleImage}
                      setShowAllImage={setShowAllImage}
                      setIsLoading={setIsLoading}
                      selectedItem={selectedItem}
                      setIsConfirmDelete={setIsConfirmDelete}
                      handleConfirmDelete={handleConfirmDelete}
                    />
                  </HStack>
                </div>
              </ScrollView>

              {(alertMessage || successMessage) && (
                <HStack alignItems={"center"} justifyContent={"center"}>
                  <Text
                    fontSize={16}
                    color={alertMessage ? "danger.600" : "success.600"}
                  >
                    {alertMessage || successMessage}
                  </Text>
                </HStack>
              )}

              {isOpenBox && (
                <ExternalLink
                  setIsOpenBox={setIsOpenBox}
                  setIsOneDriveData={setIsOneDriveData}
                  setIsYouTube={setIsYouTube}
                  setIsOpenCemera={setIsOpenCemera}
                  setCameraMode={setCameraMode}
                  imageInputRef={imageInputRef}
                  menuRefs={menuRefs}
                  handleOpenPicker={handleOpenPicker}
                  setExternalLink={setExternalLink}
                  HandleAddOneDrive={HandleAddOneDrive}
                  setShowExternalLinkInput={setShowExternalLinkInput}
                  showExternalLinkInput={showExternalLinkInput}
                  HandleAddDropBoxLink={HandleAddDropBoxLink}
                />
              )}

              <input
                type="file"
                accept="image/jpeg,image/jfif,image/png,image/gif,video/mp4,"
                multiple
                hidden
                ref={imageInputRef}
                onChange={handleImages}
              />

              {/* AddToYourPost, Cancel & Publish Buttons */}
              <Box position="relative" zIndex={10}>
                <HStack
                  justifyContent="space-between"
                  alignItems="center"
                  w="100%"
                >
                  {/*Left: Add to Post */}
                  <HStack alignItems="center" space={3}>
                    <Pressable
                      position={"relative"}
                      bottom={0}
                      onPress={() => {
                        setIsOpenBox(!isOpenBox);
                        const closeBtn = document.querySelector(
                          ".se-btn.se-dialog-close",
                        ) as HTMLElement | null;
                        closeBtn?.click();
                      }}
                      _hover={{ bgColor: "gray.100" }}
                      borderRadius={"10px"}
                      margin={"3px"}
                    >
                      <HStack space={3}>
                        <Button
                          padding={"15px"}
                          rounded={"full"}
                          _hover={{
                            opacity: 0.8,
                          }}
                          onPress={() => {
                            setIsOpenBox(!isOpenBox);
                            const closeBtn = document.querySelector(
                              ".se-btn.se-dialog-close",
                            ) as HTMLElement | null;
                            closeBtn?.click();
                          }}
                          backgroundColor={"AVColor.primary"}
                        >
                          {!isOpenBox ? (
                            <AddIcon size={"15px"} color="AVColor.white" />
                          ) : (
                            <CloseIcon size={"15px"} color="AVColor.white" />
                          )}
                        </Button>
                        {!mobile && (
                          <Text
                            alignSelf={"center"}
                            fontSize={"18px"}
                            fontWeight={400}
                          >
                            {Loc.currentLang.post.addToYourPost}
                          </Text>
                        )}
                      </HStack>
                    </Pressable>
                  </HStack>

                  {/*  Right: Footer Buttons */}
                  <HStack space={3}>
                    <Button
                      height={"40px"}
                      width={"180px"}
                      backgroundColor={" rgba(238, 238, 238, 1)"}
                      borderRadius={"full"}
                      onPress={() => {
                        setShowCreatePost(false);
                        dispatch(setPostPopupExpanded(false));
                      }}
                    >
                      <Text
                        fontWeight={400}
                        color={"rgba(0, 0, 0, 0.5)"}
                        fontSize={"16px"}
                      >
                        <Text
                          fontWeight={400}
                          color={"rgba(0, 0, 0, 0.5)"}
                          fontSize={"16px"}
                        >
                          {Loc.currentLang.menu.cancel}
                        </Text>
                      </Text>
                    </Button>

                    <Button
                      height={"40px"}
                      width={"180px"}
                      backgroundColor={"AVColor.primary"}
                      borderRadius={"full"}
                      isDisabled={
                        ((!useRichText &&
                          (!text || text.trim().length === 0)) ||
                          (useRichText && !hasContent(rteValue))) &&
                        (!images || images.length === 0) &&
                        (!videos || videos.length === 0) &&
                        (!allMedia || allMedia.length === 0)
                      }
                      onPress={handleUpdatePost}
                      isLoading={isLoading || isImageProcessing}
                      isLoadingText={
                        isImageProcessing
                          ? Loc.currentLang.post.processing
                          : Loc.currentLang.post.publishing
                      }
                    >
                      <Text color={"white"} fontWeight={400} fontSize={"16px"}>
                        {Loc.currentLang.menu.publish}
                      </Text>
                    </Button>
                  </HStack>
                </HStack>
              </Box>
            </VStack>
          </div>
        </Box>
      )}

      {showExternalLinkInput && !isOpenCemera && (
        <Box
          position="fixed"
          bgColor={"AVColor.overlay2"}
          bottom={0}
          right={0}
          top={0}
          left={0}
          zIndex={99999}
        >
          <div
            className={`create_post_popup ${
              isMobile && "create_post_popup_mobile"
            }`}
            style={{
              width: isMobile ? dimensions.width - 15 : "565px",
              height: isMobile ? "650px" : "240px",
              marginTop: "12px",
            }}
          >
            <VStack width={"100%"} padding={"24px"}>
              <HStack
                justifyContent={"space-between"}
                width={"100%"}
                alignItems={"center"}
                marginTop={"20px"}
                borderBottomColor={"AVColor.grey"}
              >
                <Text fontSize={"24px"}>
                  {isYoutube
                    ? Loc.currentLang.menu.addYoutubeUrl
                    : Loc.currentLang.postPopup.addPostUrl}
                </Text>
                <AVCancel
                  callback={() => {
                    setShowExternalLinkInput(false);
                  }}
                  color={undefined}
                  size={undefined}
                />
              </HStack>
              <HStack width={"100%"} marginTop={"24px"}>
                <Box width={"95%"} justifyContent="center">
                  <AVInputtext
                    type={"text"}
                    label={
                      isYoutube
                        ? Loc.currentLang.menu.addYoutubeUrl
                        : Loc.currentLang.postPopup.addPostUrl
                    }
                    maxLength={undefined}
                    onChange={handleExternalLink}
                    defaultValue={undefined}
                    width={undefined}
                    value={externalLink}
                    height={"20px"}
                    minRows={undefined}
                    multiline={undefined}
                    size={undefined}
                    placeholder={undefined}
                  />
                </Box>
              </HStack>
              <HStack
                justifyContent={"center"}
                space={"24px"}
                marginTop={"24px"}
              >
                <Button
                  width={"180px"}
                  height={"40px"}
                  backgroundColor={"AVColor.primary"}
                  rounded={"full"}
                  isDisabled={externalLink?.trim().length === 0}
                  isLoading={addLinkLoad}
                  onPress={() => HandleAddLinkToMedia()}
                >
                  <Text fontWeight={500} color={"white"}>
                    {Loc.currentLang.menu.ok}
                  </Text>
                </Button>
              </HStack>
            </VStack>
          </div>
        </Box>
      )}

      {isOpenCemera && (
        <Box
          position="fixed"
          bgColor="rgba(0, 0, 0, 0.25)"
          bottom={0}
          right={0}
          top="40px"
          left={0}
          zIndex={99999}
          display="flex"
          alignItems="center"
          justifyContent="center"
          overflowY="auto"
          px="16px"
        >
          <Box
            bg="white"
            borderRadius="12px"
            p="20px"
            w="100%"
            maxW="750px"
            maxH="95vh"
            overflowY="auto"
          >
            <VStack space={4}>
              {/* Webcam preview */}
              <Box w="100%" position="relative">
                <Webcam
                  audio={cameraMode === "video"}
                  ref={webcamRef}
                  screenshotFormat="image/jpeg"
                  videoConstraints={{ facingMode: "user" }}
                  style={{
                    width: "100%",
                    height: "400px",
                    borderRadius: "8px",
                    objectFit: "cover",
                  }}
                />

                {/* Timer Overlay */}
                {cameraMode === "video" && recording && (
                  <Box
                    position="absolute"
                    top="12px"
                    right="16px"
                    px="8px"
                    py="4px"
                    backgroundColor="rgba(0,0,0,0.6)"
                    borderRadius="md"
                  >
                    <Text color="white" fontWeight="bold" fontSize="md">
                      ⏺ {formatDuration(duration)}
                    </Text>
                  </Box>
                )}
              </Box>

              {/* Buttons */}
              <HStack
                flexWrap="wrap"
                justifyContent="flex-end"
                space={3}
                mt="20px"
                zIndex={100000}
              >
                {/* Toggle Camera Mode */}
                <div
                  className="toggleContainer"
                  style={{ display: "none", gap: "12px" }}
                >
                  <div
                    className={`iconBox ${cameraMode === "photo" ? "active" : "inactive"}`}
                    onClick={() => toggleMode()}
                  >
                    <FiCamera size={24} />
                  </div>
                  <div
                    className={`iconBox ${cameraMode === "video" ? "active" : "inactive"}`}
                    onClick={() => toggleMode()}
                  >
                    <FiVideo size={24} />
                  </div>
                </div>

                {/* Cancel Button */}
                <Button
                  height="40px"
                  minW="120px"
                  backgroundColor="rgba(238, 238, 238, 1)"
                  borderRadius="full"
                  onPress={() => {
                    if (recording) {
                      isCancelledRef.current = true;
                      handleStopRecording();
                    }
                    onClose();
                  }}
                >
                  <Text
                    color="rgba(0, 0, 0, 0.5)"
                    fontSize="16px"
                    fontWeight={400}
                  >
                    {Loc.currentLang.postPopup.cancel}
                  </Text>
                </Button>

                {/* Capture / Record Button */}
                {cameraMode === "photo" ? (
                  <Button
                    height="40px"
                    minW="120px"
                    backgroundColor="AVColor.primary"
                    borderRadius="full"
                    isLoading={isImageProcessing}
                    onPress={handleCameraPhotoCapture}
                    isDisabled={!isCameraAccessible}
                  >
                    <Text color="white" fontSize="16px" fontWeight={400}>
                      {Loc.currentLang.postPopup.capture}
                    </Text>
                  </Button>
                ) : (
                  <Button
                    height="40px"
                    minW="120px"
                    backgroundColor={recording ? "red.500" : "AVColor.primary"}
                    borderRadius="full"
                    isDisabled={!isCameraAccessible}
                    onPress={() => {
                      if (recording) {
                        isCancelledRef.current = false;
                        handleStopRecording();
                      } else {
                        handleStartRecording();
                      }
                    }}
                  >
                    <Text color="white" fontSize="16px" fontWeight={400}>
                      {recording
                        ? Loc.currentLang.postPopup.stop
                        : Loc.currentLang.postPopup.record}
                    </Text>
                  </Button>
                )}
              </HStack>
            </VStack>
          </Box>
        </Box>
      )}

      {showBoostPostPopup && (
        <AVBoostPostPopup
          entity={item?.owner ?? currentUser}
          paySend={paySend}
          setPaySend={setPaySend}
          subject={subject}
          setSubject={setSubject}
          estimate={estimate}
          setEstimate={setEstimate}
          showBoostPostPopup={showBoostPostPopup}
          setShowBoostPostPopup={setShowBoostPostPopup}
          showCreditsPopup={showCreditsPopup}
          setShowCreditsPopup={setShowCreditsPopup}
          boostPostOwner={item?.owner ?? currentUser?.owner}
          editPostPaySend={item?.paySend}
          editPostSubject={item?.subject}
          sharedPlan={sharedPlan}
          setSharedPlan={setSharedPlan}
          handleToggleRichTextPost={handleToggleRichTextPost}
          handleToggleRichTextSubject={handleToggleRichTextSubject}
          visibility={estimateVisibility || visibility}
        />
      )}

      {showCreditsPopup && (
        <Box
          position="fixed"
          bgColor="rgba(0, 0, 0, 0.25)"
          bottom={0}
          right={0}
          top="40px"
          left={0}
          zIndex={99999}
          display="flex"
          alignItems="center"
          justifyContent="center"
          overflowY="auto"
          px="16px"
        >
          <PurchaseCreditsPopup
            entity={
              item?.owner?.type === "Event" ||
              item?.owner?.type === "Game" ||
              item?.owner?.type === "Channel"
                ? item?.topOwner
                : (item?.owner ?? currentUser)
            }
            sharedPlan={sharedPlan}
            setSharedPlan={setSharedPlan}
            showCreditsPopup={showCreditsPopup}
            setShowCreditsPopup={setShowCreditsPopup}
          />
        </Box>
      )}

      {isConfirmDelete && (
        <Box
          position="fixed"
          bgColor="rgba(0, 0, 0, 0.25)"
          bottom={0}
          right={0}
          top="40px"
          left={0}
          zIndex={99999}
          display="flex"
          alignItems="center"
          justifyContent="center"
          overflowY="auto"
          px="16px"
        >
          <AVConfirmationModal
            showconfirmationPopup={isConfirmDelete}
            setshowconfirmationPopup={setIsConfirmDelete}
            Confirmationtext={confirmationText}
            type={selectedType}
            item={selectedItem}
            function={handleCancelImage}
            isLoader={isLoading}
          />
        </Box>
      )}
    </>
  );
};

export default EditPostpopup;
